/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import SvgIcon from '@material-ui/core/SvgIcon';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
    width: '70%',
  },
  iconHover: {
    '&:hover': {
   //   backgroundColor: '#333',
  //    fill: green[200],
    },
  //  width: 40,
  //  height: 40,
 //   margin: '5px',
 //   cursor: 'pointer',
  //  boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
  },
};

export const Saverst = props => <SvgIcon viewBox="-13 -13 32 32" style={styles.iconHover} {...props}>
<path fill="#FFFFFF" d="M12.67,5.16H1.18c-0.43,0-0.77-0.35-0.77-0.77s0.35-0.77,0.77-0.77h11.48c0.43,0,0.77,0.35,0.77,0.77
  S13.09,5.16,12.67,5.16z"/>
</SvgIcon>;

export const Twitter = props => <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
  <path fill="#6596D0" d="M29.72,14.94c0,8.2-6.65,14.85-14.85,14.85c-8.2,0-14.85-6.65-14.85-14.85c0-8.2,6.65-14.85,14.85-14.85
C23.08,0.1,29.72,6.74,29.72,14.94"/>
  <path fill="#FFFFFF" d="M12.8,21.65c5.6,0,8.67-4.64,8.67-8.67c0-0.13,0-0.26-0.01-0.39c0.59-0.43,1.11-0.97,1.52-1.58
c-0.55,0.24-1.13,0.41-1.75,0.48c0.63-0.38,1.11-0.97,1.34-1.68c-0.59,0.35-1.24,0.6-1.93,0.74c-0.56-0.59-1.35-0.96-2.22-0.96
c-1.68,0-3.05,1.36-3.05,3.05c0,0.24,0.03,0.47,0.08,0.69c-2.53-0.13-4.78-1.34-6.28-3.18c-0.26,0.45-0.41,0.97-0.41,1.53
c0,1.06,0.54,1.99,1.36,2.54c-0.5-0.02-0.97-0.15-1.38-0.38c0,0.01,0,0.03,0,0.04c0,1.48,1.05,2.71,2.44,2.99
c-0.26,0.07-0.52,0.11-0.8,0.11c-0.2,0-0.39-0.02-0.57-0.05c0.39,1.21,1.51,2.09,2.85,2.12c-1.04,0.82-2.36,1.3-3.78,1.3
c-0.25,0-0.49-0.01-0.73-0.04C9.48,21.14,11.08,21.65,12.8,21.65"/>
</SvgIcon>;

export const Facebook = props => <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
  <path fill="#486EB2" d="M29.76,14.91c0-8.2-6.65-14.85-14.85-14.85S0.07,6.71,0.07,14.91c0,7.41,5.43,13.55,12.53,14.66V19.2H8.83
    v-4.29h3.77v-3.27c0-3.72,2.22-5.78,5.61-5.78c1.62,0,3.32,0.29,3.32,0.29V9.8h-1.87c-1.84,0-2.42,1.14-2.42,2.32v2.78h4.12
    L20.7,19.2h-3.46v10.37C24.34,28.46,29.76,22.32,29.76,14.91z"/>
  <path fill="#FFFFFF" d="M20.7,19.2l0.66-4.29h-4.12v-2.78c0-1.17,0.58-2.32,2.42-2.32h1.87V6.15c0,0-1.7-0.29-3.32-0.29
    c-3.39,0-5.61,2.06-5.61,5.78v3.27H8.83v4.29h3.77v10.37c0.76,0.12,1.53,0.18,2.32,0.18s1.56-0.06,2.32-0.18V19.2H20.7z"/>
</SvgIcon>;

export const AboutApp = props => <SvgIcon viewBox="-7 -7 32 32" style={styles.iconHover} {...props}>
  <rect x="8.18" y="7.11" width="1.52" height="6.15"/>
  <rect x="8.18" y="4.69" width="1.52" height="1.44"/>
  <path d="M8.94,17.85c-4.89,0-8.87-3.98-8.87-8.87S4.05,0.1,8.94,0.1c4.89,0,8.87,3.98,8.87,8.87
    S13.83,17.85,8.94,17.85z M8.94,1.4c-4.17,0-7.57,3.4-7.57,7.57s3.4,7.57,7.57,7.57c4.17,0,7.57-3.4,7.57-7.57S13.12,1.4,8.94,1.4z
    "/>
</SvgIcon>;

export const BalticmapsLogo = props => (
  <SvgIcon viewBox="-6 -5 30 40" style={styles.iconHover} {...props}>
		<path fill="#FFFFFF" d="M10.9,33.7c-0.2,0-0.5-0.1-0.7-0.2l-2.5-2.2c-0.2-0.2-0.3-0.4-0.3-0.6L7,27.8l-3.6-0.9
			c-0.4-0.1-0.7-0.4-0.7-0.8l-1.1-6.5c0-0.2,0-0.3,0-0.5l2.1-5.8C3.8,13,4,12.8,4.2,12.7l2-1.1c0.4-0.2,0.9-0.1,1.2,0.2l3.1,3.2
			l2.1-1L11.8,10l-0.5,0.2c-0.2,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.4-0.3-0.5-0.6L8.5,5.2c-0.2-0.5,0-1,0.4-1.2l5.3-3.2
			c0.2-0.1,0.4-0.2,0.6-0.1l7.4,0.8c0.3,0,0.6,0.2,0.7,0.5s0.2,0.6,0.1,0.9l-1.5,3.9l1.2,3.8c0.1,0.3,0.1,0.5-0.1,0.8l-0.6,1.1
			l0.9,0.8c0.1,0.1,0.2,0.3,0.3,0.5l1.5,5c0.1,0.3,0,0.5-0.1,0.8l-1.5,2.7c-0.1,0.2-0.3,0.4-0.5,0.5l-2.1,0.8l0,0.2l0.4,0.1
			c0.3,0.1,0.5,0.3,0.6,0.6c0.1,0.3,0.1,0.6-0.1,0.9L18.1,30l0.2,1.4c0.1,0.5-0.3,1-0.8,1.1l-6.4,1.1C11,33.7,11,33.7,10.9,33.7z
			 M9.3,30l1.9,1.6l5-0.9l-0.1-0.9c0-0.2,0-0.5,0.2-0.7l2.7-4.1c-0.4-0.2-0.6-0.6-0.6-1l0.2-1.6c0-0.4,0.3-0.7,0.6-0.8l2.4-0.9
			l1.1-2l-1.3-4.3l-1.3-1.1c-0.4-0.3-0.4-0.8-0.2-1.2l0.8-1.4L19.5,7c-0.1-0.2-0.1-0.4,0-0.7l1.1-3l-5.8-0.6l-4.3,2.6l1,2.6l0.7-0.2
			c0.3-0.1,0.6-0.1,0.8,0.1c0.3,0.1,0.4,0.4,0.5,0.7l1.1,6c0.1,0.4-0.1,0.9-0.6,1.1l-3.4,1.6c-0.4,0.2-0.8,0.1-1.1-0.2l-3.1-3.2
			l-1,0.6l-1.9,5.2l0.9,5.6L8.2,26c0.4,0.1,0.7,0.4,0.7,0.8L9.3,30z"/>
		<path fill="#FFFFFF" d="M5.5,11.3c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.5-0.4-0.6-0.8L4.1,7.7c0-0.3,0-0.6,0.2-0.8l1.5-1.7
			c0.4-0.4,1-0.5,1.4-0.1l2.4,2C9.9,7.3,10,7.6,10,7.9S9.8,8.5,9.6,8.7l-3.5,2.4C5.9,11.2,5.7,11.3,5.5,11.3z M6.2,7.9l0.1,0.7
			l1.1-0.7L6.7,7.3L6.2,7.9z"/>
  </SvgIcon>
);

export const BalticmapsText = props => (
  <SvgIcon viewBox="50 -6 26 26" style={styles.iconHover} {...props}>
	<path fill="#ffffff" d="M12.1,11.9c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1c-0.3,0.3-0.7,0.5-1.2,0.7c-0.5,0.2-0.9,0.2-1.5,0.2
		H2.3V2.4h6.4c0.4,0,0.8,0.1,1.2,0.3s0.7,0.4,0.9,0.8c0.3,0.3,0.4,0.7,0.6,1s0.2,0.8,0.2,1.2c0,0.6-0.2,1.2-0.5,1.8
		C10.8,8,10.3,8.4,9.7,8.7c0.7,0.2,1.3,0.6,1.7,1.2S12.1,11.1,12.1,11.9z M3.9,3.8v4.3H8c0.3,0,0.6-0.1,0.8-0.2
		C9,7.8,9.2,7.7,9.4,7.5s0.3-0.4,0.4-0.7C9.9,6.5,10,6.3,10,6c0-0.3,0-0.6-0.1-0.9C9.7,4.9,9.6,4.6,9.4,4.4C9.3,4.2,9.1,4.1,8.8,4
		C8.6,3.9,8.3,3.8,8.1,3.8H3.9z M10.5,11.6c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.3-0.2-0.5-0.4-0.7S9.5,9.7,9.3,9.6C9,9.5,8.8,9.4,8.5,9.4
		H3.9v4.4h4.5c0.3,0,0.6-0.1,0.8-0.2c0.3-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.3-0.4,0.5-0.7C10.4,12.2,10.5,11.9,10.5,11.6z"/>
	<path fill="#ffffff" d="M16.9,15.4c-0.4,0-0.9-0.1-1.2-0.2s-0.7-0.4-1-0.6c-0.3-0.3-0.5-0.6-0.7-0.9c-0.2-0.4-0.2-0.7-0.2-1.2
		c0-0.4,0.1-0.8,0.3-1.2c0.2-0.4,0.5-0.7,0.8-0.9s0.8-0.5,1.3-0.6s1-0.2,1.6-0.2c0.5,0,0.9,0,1.4,0.1c0.5,0.1,0.9,0.2,1.2,0.3V9.3
		c0-0.8-0.2-1.4-0.7-1.8c-0.4-0.4-1-0.7-1.8-0.7c-1,0-2,0.4-3,1.1l-0.5-1c1.2-0.8,2.4-1.2,3.7-1.2c1.2,0,2.2,0.3,2.9,1
		c0.7,0.7,1,1.6,1,2.8v3.9c0,0.4,0.2,0.6,0.5,0.6v1.4c-0.2,0-0.3,0-0.4,0.1c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6-0.1-0.8-0.3
		c-0.2-0.2-0.3-0.4-0.3-0.7l0-0.7c-0.4,0.6-1,1-1.6,1.3S17.6,15.4,16.9,15.4z M17.3,14.2c0.6,0,1.1-0.1,1.6-0.3s0.9-0.5,1.1-0.8
		c0.2-0.2,0.3-0.5,0.3-0.7V11c-0.8-0.3-1.6-0.5-2.4-0.5c-0.8,0-1.4,0.2-1.9,0.5c-0.5,0.3-0.8,0.8-0.8,1.3c0,0.3,0.1,0.5,0.2,0.7
		c0.1,0.2,0.2,0.4,0.4,0.6s0.4,0.3,0.7,0.4C16.8,14.2,17,14.2,17.3,14.2z"/>
	<path fill="#ffffff" d="M24.9,2h1.6v10.8c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.3,0.8,0.3c0.1,0,0.3,0,0.5-0.1s0.3-0.1,0.5-0.2l0.3,1.3
		c-0.3,0.1-0.6,0.2-0.9,0.3s-0.7,0.1-1,0.1c-0.6,0-1.1-0.2-1.5-0.5c-0.4-0.3-0.5-0.8-0.5-1.5V2z"/>
	<path fill="#ffffff" d="M35.3,14.8c-0.1,0-0.2,0.1-0.4,0.2s-0.3,0.1-0.5,0.2c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0-0.5,0.1-0.7,0.1
		c-0.6,0-1.1-0.2-1.5-0.5s-0.6-0.8-0.6-1.5V7.1h-1.3V5.8h1.3V2.7h1.6v3.1h2.1v1.2h-2.1v5.9c0,0.3,0.1,0.6,0.3,0.8
		c0.2,0.2,0.4,0.2,0.7,0.2c0.3,0,0.6-0.1,0.9-0.2s0.4-0.2,0.5-0.2L35.3,14.8z"/>
	<path fill="#ffffff" d="M37.1,4V2h1.6v2H37.1z M37.1,15.2V5.8h1.6v9.4H37.1z"/>
	<path fill="#ffffff" d="M41,10.5c0-0.7,0.1-1.3,0.3-1.9c0.2-0.6,0.6-1.1,1-1.5s0.9-0.8,1.5-1c0.6-0.3,1.2-0.4,2-0.4
		c0.9,0,1.8,0.2,2.4,0.6c0.7,0.4,1.2,1,1.5,1.7l-1.6,0.5c-0.2-0.4-0.6-0.8-1-1C46.8,7.1,46.3,7,45.8,7c-0.4,0-0.8,0.1-1.2,0.3
		c-0.4,0.2-0.7,0.4-1,0.7S43,8.7,42.9,9.1c-0.2,0.4-0.2,0.9-0.2,1.4c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.4,0.8,0.7,1.1
		c0.3,0.3,0.6,0.6,1,0.8c0.4,0.2,0.8,0.3,1.2,0.3c0.3,0,0.6,0,0.8-0.1c0.3-0.1,0.5-0.2,0.7-0.3c0.2-0.1,0.4-0.3,0.6-0.5
		s0.3-0.4,0.4-0.6l1.6,0.5c-0.1,0.3-0.3,0.7-0.6,1c-0.3,0.3-0.6,0.5-0.9,0.7c-0.3,0.2-0.7,0.4-1.2,0.5s-0.9,0.2-1.3,0.2
		c-0.7,0-1.4-0.1-2-0.4c-0.6-0.3-1.1-0.6-1.5-1.1s-0.8-1-1-1.6C41.1,11.8,41,11.2,41,10.5z"/>
	<path fill="#ffffff" d="M62.5,15.2V6.7l-3.3,6.3h-1.4l-3.3-6.3v8.5h-2.5V2.4h2.7l3.8,7.3l3.8-7.3H65v12.8H62.5z"/>
	<path fill="#ffffff" d="M70.3,15.4c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.7-0.4-1-0.6s-0.5-0.6-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.2
		c0-0.4,0.1-0.9,0.3-1.2c0.2-0.4,0.5-0.7,0.8-1s0.8-0.5,1.3-0.6c0.5-0.2,1-0.2,1.6-0.2c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.8,0.2,1.1,0.3
		V9.2c0-0.6-0.2-1.1-0.5-1.4c-0.4-0.3-0.9-0.5-1.6-0.5c-0.5,0-1,0.1-1.5,0.3c-0.5,0.2-1,0.4-1.5,0.8l-0.7-1.5
		c1.2-0.8,2.5-1.2,3.9-1.2c1.4,0,2.4,0.3,3.2,1c0.8,0.7,1.1,1.6,1.1,2.9v2.9c0,0.3,0,0.4,0.1,0.5c0.1,0.1,0.2,0.2,0.4,0.2v2.1
		c-0.4,0.1-0.8,0.1-1.1,0.1c-0.5,0-0.8-0.1-1.1-0.3s-0.4-0.5-0.5-0.8l-0.1-0.5c-0.4,0.6-0.9,1-1.5,1.3C71.7,15.3,71,15.4,70.3,15.4z
		 M71,13.7c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.3,0.9-0.6c0.3-0.2,0.4-0.4,0.4-0.7v-1.1c-0.3-0.1-0.6-0.2-0.9-0.3
		c-0.3-0.1-0.7-0.1-1-0.1c-0.6,0-1.1,0.1-1.5,0.4s-0.6,0.6-0.6,1.1c0,0.4,0.2,0.8,0.5,1C70.2,13.5,70.6,13.7,71,13.7z"/>
	<path fill="#ffffff" d="M84.2,15.4c-0.7,0-1.4-0.2-2-0.5c-0.6-0.3-1-0.8-1.3-1.3v5.5h-2.4V5.8h2.1v1.6c0.3-0.6,0.8-1,1.4-1.3
		c0.6-0.3,1.2-0.5,1.9-0.5c0.6,0,1.2,0.1,1.8,0.4c0.5,0.3,1,0.6,1.4,1s0.7,1,0.9,1.6c0.2,0.6,0.3,1.2,0.3,1.9c0,0.7-0.1,1.3-0.3,1.9
		c-0.2,0.6-0.5,1.1-0.9,1.6c-0.4,0.4-0.8,0.8-1.3,1C85.3,15.3,84.8,15.4,84.2,15.4z M83.4,13.4c0.4,0,0.7-0.1,1-0.2
		c0.3-0.2,0.6-0.4,0.8-0.6c0.2-0.3,0.4-0.6,0.5-0.9c0.1-0.3,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.3-0.3-0.6-0.6-0.9
		c-0.2-0.3-0.5-0.5-0.8-0.6c-0.3-0.1-0.7-0.2-1-0.2c-0.2,0-0.5,0-0.7,0.1S82,8,81.8,8.1c-0.2,0.1-0.4,0.3-0.6,0.5
		C81.1,8.8,81,9,80.9,9.3v2.2c0.2,0.5,0.5,1,1,1.3C82.4,13.2,82.8,13.4,83.4,13.4z"/>
	<path fill="#ffffff" d="M93.9,15.4c-0.8,0-1.6-0.1-2.3-0.4c-0.8-0.3-1.4-0.6-2-1.1l0.9-1.5c0.6,0.4,1.1,0.7,1.7,0.9
		c0.5,0.2,1.1,0.3,1.6,0.3c0.5,0,0.9-0.1,1.1-0.3c0.3-0.2,0.4-0.4,0.4-0.8c0-0.3-0.2-0.6-0.5-0.7c-0.3-0.2-0.9-0.3-1.6-0.5
		c-0.6-0.2-1.1-0.3-1.6-0.5c-0.4-0.2-0.8-0.3-1-0.5c-0.3-0.2-0.5-0.4-0.6-0.7c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.5,0.1-0.9,0.3-1.3
		c0.2-0.4,0.4-0.7,0.8-1c0.3-0.3,0.7-0.5,1.2-0.6c0.5-0.1,0.9-0.2,1.5-0.2c0.7,0,1.4,0.1,2,0.3c0.6,0.2,1.2,0.5,1.7,1l-1,1.5
		C95.9,8,95.4,7.7,95,7.6s-0.9-0.3-1.3-0.3c-0.4,0-0.8,0.1-1,0.3S92.2,8,92.2,8.4c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.3
		c0.1,0.1,0.3,0.2,0.6,0.2c0.2,0.1,0.5,0.2,0.9,0.2c0.7,0.2,1.2,0.3,1.7,0.5c0.5,0.2,0.8,0.4,1.1,0.6c0.3,0.2,0.5,0.5,0.7,0.8
		s0.2,0.6,0.2,1c0,0.9-0.3,1.7-1,2.2C96,15.2,95.1,15.4,93.9,15.4z"/>
  </SvgIcon>
);

export const LayerChange = props => <SvgIcon viewBox="-2 -2 28 28" {...props}>
<path d="M24.78,3.26h-3.95V0.75c0-0.41-0.34-0.75-0.75-0.75H1C0.58,0,0.25,0.34,0.25,0.75v19.08
  c0,0.27,0.15,0.5,0.36,0.63c0.03,0.04,3.34,0.12,3.34,0.12v3.51c0,0.41,0.34,0.75,0.75,0.75h20.08c0.41,0,0.75-0.34,0.75-0.75V4.01
  C25.53,3.6,25.19,3.26,24.78,3.26z M17.76,19.08c-0.02-0.02-0.03-0.05-0.05-0.07l-4.33-3.8l5.95-5.86v9.74H17.76z M19.33,1.5v5.74
  l-7.08,6.97L1.75,4.99c0,0,0,0,0,0V1.5H19.33z M1.75,6.98l6.2,5.45l-6.2,6.08V6.98z M9,13.5c0.03-0.03,0.04-0.06,0.06-0.09
  l6.46,5.67H3.31L9,13.5z M24.03,23.34H5.45v-2.76h14.63c0.41,0,0.75-0.34,0.75-0.75V4.76h3.2V23.34z"/>
<path d="M11.52,11.73c0.14,0.12,0.31,0.18,0.48,0.18c0.21,0,0.41-0.08,0.56-0.25l3.14-3.51C15.83,8,15.9,7.8,15.88,7.6
  s-0.11-0.39-0.26-0.52l-4.69-3.95C10.62,2.87,10.16,2.9,9.89,3.2L6.75,6.71c-0.13,0.15-0.2,0.35-0.19,0.55s0.11,0.39,0.26,0.52
  L11.52,11.73z M10.52,4.74l3.54,2.98l-2.14,2.39L8.38,7.14L10.52,4.74z"/>
</SvgIcon>;


export const Point = props => (
  <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
    <path d="M18.066 15.941c0 0.978-0.793 1.771-1.771 1.771s-1.771-0.793-1.771-1.771c0-0.978 0.793-1.771 1.771-1.771s1.771 0.793 1.771 1.771z"></path>
  </SvgIcon>
);

//-7 -5 22 22
export const Help = props => (
  <SvgIcon
     viewBox="0 0 16.2 16.2" {...props}>
  <path fill="#ffffff" d="M8.8,10.1H7.3c0-0.2,0-0.3,0-0.4c0-0.4,0.1-0.8,0.2-1.1c0.2-0.4,0.6-0.7,0.9-1C8.8,7.4,9,7.1,9.3,6.9
    c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.4-1-0.3c-0.4,0-0.7,0.1-1,0.3c-0.3,0.3-0.5,0.6-0.5,1L5.1,6.3
    C5.2,5.7,5.5,5,6,4.6c0.6-0.5,1.3-0.7,2.1-0.7c0.8,0,1.6,0.2,2.2,0.7C10.7,5,11,5.6,11,6.3c0,0.4-0.1,0.7-0.3,1
    C10.4,7.7,10,8.2,9.5,8.5C9.2,8.7,9,8.9,8.9,9.2C8.8,9.5,8.7,9.8,8.8,10.1z M7.3,12.2v-1.6h1.6v1.6H7.3z"/>
  <circle fill="none" stroke="#FFFFFF" cx="8.1" cy="8.1" r="7.4"/>
  </SvgIcon>
);

export const Circle = props => (
  <SvgIcon viewBox="0 0 30 30" style={styles.iconHover} {...props}>
    <circle fill="#B2BEC9" stroke="#00264A" strokeWidth="1.1" cx="13.9" cy="14" r="6.5"/>
</SvgIcon>
);

export const Line = props => (
  <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
    <path d="M21.845 22.199l0.118-10.745c0.709-0.236 1.181-0.945 1.181-1.653 0-0.945-0.827-1.771-1.771-1.771s-1.771 0.827-1.771 1.771c0 0.118 0 0.236 0 0.236l-10.037 5.55c-0.354-0.236-0.709-0.472-1.181-0.472-0.945 0-1.771 0.827-1.771 1.771s0.827 1.771 1.771 1.771c0.945 0 1.771-0.827 1.771-1.771 0-0.118 0-0.236 0-0.236l10.037-5.55c0.118 0.118 0.354 0.236 0.59 0.354l-0.118 10.863c-0.59 0.236-1.063 0.945-1.063 1.653 0 0.945 0.827 1.771 1.771 1.771s1.771-0.827 1.771-1.771c0-0.945-0.472-1.653-1.299-1.771z"></path>
  </SvgIcon>
);

export const Minus = props => (
  <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
    <path d="M23.616 17.24h-14.996c-0.708 0-1.181-0.472-1.181-1.181s0.472-1.181 1.181-1.181h14.996c0.709 0 1.181 0.472 1.181 1.181s-0.472 1.181-1.181 1.181z"></path>
  </SvgIcon>
);

export const Clear = props => (
  <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
    <path d="M11.572 24.443h9.565l1.181-12.635h-11.926l1.181 12.635zM21.137 12.989l-1.063 10.273h-7.557l-0.827-10.273h9.447z"></path>
    <path d="M9.919 11.1h12.989v-1.181h-4.015c-0.236-1.181-1.181-2.125-2.48-2.125s-2.244 0.945-2.48 2.125h-4.015v1.181zM16.295 8.974c0.59 0 1.181 0.472 1.299 0.945h-2.598c0.118-0.472 0.709-0.945 1.299-0.945z"></path>
    <path d="M17.124 22.212l0.642-8.359 1.177 0.090-0.642 8.359-1.177-0.090z"></path>
    <path d="M13.738 13.989l1.177-0.091 0.643 8.359-1.177 0.091-0.643-8.359z"></path>
  </SvgIcon>
);

export const Plus = props => (
  <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
    <path d="M23.734 17.24h-15.114c-0.708 0-1.181-0.472-1.181-1.181s0.472-1.181 1.181-1.181h15.114c0.709 0 1.181 0.472 1.181 1.181s-0.59 1.181-1.181 1.181z"></path>
    <path d="M16.177 24.679c-0.709 0-1.181-0.472-1.181-1.181v-14.996c0-0.708 0.472-1.181 1.181-1.181s1.181 0.472 1.181 1.181v15.114c0 0.59-0.59 1.063-1.181 1.063z"></path>
  </SvgIcon>
);

export const Polygon = props => (
  <SvgIcon viewBox="0 0 28 28" style={styles.iconHover} {...props}>
      <polyline  fill="#667D92" points="18.2,19.6 18.3,8 7.3,14 18.3,20 "/>
      <circle cx="18.3" cy="20" r="1.8"/>
      <circle cx="7.3" cy="14" r="1.8"/>
      <circle cx="18.3" cy="8" r="1.8"/>
        <path d="M18.85,20.93L6.15,14l12.7-6.93V20.93z M8.45,14l9.3,5.07V8.93L8.45,14z"/>
  </SvgIcon>
);

export const Lake = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path fill="#666" d="M26.615 19.676c-1.139 0-1.761-0.725-2.278-1.243-0.414-0.518-0.725-0.828-1.243-0.828s-0.828 0.311-1.243 0.828c-0.518 0.518-1.036 1.243-2.278 1.243-1.139 0-1.761-0.725-2.175-1.243-0.518-0.518-0.828-0.828-1.346-0.828s-0.828 0.311-1.243 0.828c-0.518 0.518-1.036 1.243-2.175 1.243s-1.761-0.725-2.175-1.243c-0.621-0.518-0.828-0.828-1.45-0.828v-1.243c1.139 0 1.761 0.725 2.175 1.243s0.725 0.828 1.243 0.828 0.828-0.311 1.243-0.828c0.518-0.518 1.036-1.243 2.175-1.243s1.761 0.725 2.175 1.243c0.414 0.518 0.725 0.828 1.243 0.828s0.828-0.311 1.243-0.828c0.518-0.518 1.036-1.243 2.278-1.243s1.761 0.725 2.278 1.243c0.414 0.518 0.725 0.828 1.243 0.828v1.243z"></path>
    <path fill="#666" d="M26.615 15.948c-1.139 0-1.761-0.725-2.278-1.243-0.414-0.518-0.725-0.828-1.243-0.828s-0.828 0.311-1.243 0.828c-0.518 0.518-1.036 1.243-2.278 1.243-1.139 0-1.761-0.725-2.175-1.243s-0.725-0.828-1.243-0.828-0.828 0.311-1.243 0.828c-0.518 0.518-1.036 1.243-2.175 1.243s-1.761-0.725-2.175-1.243c-0.414-0.518-0.725-0.828-1.243-0.828v-1.243c1.139 0 1.761 0.725 2.175 1.243s0.725 0.828 1.243 0.828 0.828-0.311 1.243-0.828c0.518-0.518 1.036-1.243 2.175-1.243s1.761 0.725 2.175 1.243c0.414 0.518 0.725 0.828 1.243 0.828s0.828-0.311 1.243-0.828c0.518-0.518 1.036-1.243 2.278-1.243s1.761 0.725 2.278 1.243c0.414 0.518 0.725 0.828 1.243 0.828v1.243z"></path>
  </SvgIcon>
);

export const Address = props => (
  <SvgIcon viewBox="-5 0 36 36" {...props}>
    <path fill="#666" d="M17.812 10.563l5.592 4.764h-0.725v7.042h-2.693v-5.074h-4.349v5.074h-2.693v-6.939h-0.725l5.592-4.867zM17.812 9.113l-8.699 7.456h2.693v6.939h4.971v-5.074h2.071v5.074h4.971v-6.939h2.693l-8.699-7.456z"></path>
  </SvgIcon>
);

export const Church = props => (
  <SvgIcon viewBox="-5 -5 36 36" {...props}>
    <path d="M14.81,7.44V5.22h1.53c0.35,0,0.64-0.29,0.64-0.64s-0.28-0.64-0.64-0.64h-1.53V2.27c0-0.35-0.28-0.64-0.64-0.64
	s-0.64,0.29-0.64,0.64v1.68H12c-0.35,0-0.64,0.29-0.64,0.64S11.64,5.23,12,5.23h1.53v2.13L4.52,18.78H7.8v8.34h3.1v0.03h6.44v-0.03
	h3.22v-8.34h3.28L14.81,7.44z M12.17,25.85v-5.89l0.02-0.43c0.05-1.04,0.9-1.86,1.93-1.86s1.89,0.81,1.93,1.86l0.02,6.32H12.17z
	 M19.29,17.51v8.34h-1.94l-0.11-6.99c-0.34-1.42-1.61-2.46-3.12-2.46s-2.78,1.04-3.12,2.46l-0.1,6.99H9.07v-8.34H7.15l7-8.87
	l7.06,8.87H19.29z"/>
  </SvgIcon>
);

export const Nature = props => (
  <SvgIcon viewBox="-4 -4 32 32" {...props}>
        <path d="M17.48,20.72c-1.14,0-2.2-0.46-3-1.28c-0.24-0.25-0.24-0.66,0.02-0.9c0.25-0.24,0.66-0.24,0.9,0.02
          c0.55,0.57,1.29,0.89,2.08,0.89c1.59,0,2.88-1.29,2.88-2.88c0-1.15-0.7-2.18-1.79-2.63l-0.75-0.31l0.48-0.65
          c0.4-0.55,0.62-1.21,0.62-1.91c0-1.66-0.73-2.28-2.69-2.28h-0.58c0,0,0.24-0.67,0.24-1.6l0-0.2c0-0.77-0.83-1.5-1.71-1.5
          c-0.88,0-1.71,0.73-1.71,1.5l0,0.2c0,0.83,0.24,1.6,0.24,1.6h-0.58c-1.96,0-2.69,0.62-2.69,2.28c0,0.7,0.21,1.36,0.62,1.91
          l0.48,0.66l-0.75,0.31c-1.1,0.45-1.79,1.46-1.79,2.63c0,1.59,1.29,2.88,2.88,2.88c0.82,0,1.62-0.33,2.15-0.89
          c0.24-0.25,0.65-0.26,0.9-0.02s0.26,0.64,0.02,0.9c-0.77,0.8-1.91,1.28-3.07,1.28c-2.29,0-4.15-1.86-4.15-4.15
          c0-1.42,0.73-2.72,1.92-3.47c-0.32-0.62-0.48-1.32-0.48-2.04c0-2.1,1-3.25,3.04-3.5C11.2,7.4,11.2,7.24,11.2,7.07
          c0-1.57,1.39-2.87,2.98-2.87c1.59,0,2.98,1.29,2.98,2.77c0,0.21,0,0.4-0.02,0.58c2.04,0.25,3.04,1.4,3.04,3.5
          c0,0.72-0.16,1.41-0.48,2.04c1.19,0.75,1.92,2.04,1.92,3.47C21.63,18.86,19.77,20.72,17.48,20.72z"/>
      <path d="M17.97,24.92h-4.41V13.88c0-0.35,0.28-0.64,0.64-0.64s0.64,0.29,0.64,0.64v9.77h3.14
        c0.35,0,0.64,0.29,0.64,0.64S18.32,24.92,17.97,24.92z"/>
  </SvgIcon>
);

export const Fuel = props => (
  <SvgIcon viewBox="-8 -5 36 36" {...props}>
  	<path d="M14.23,6.83h-4.04c-0.72,0-1.31,0.59-1.31,1.31v6.89c0,0.72,0.59,1.31,1.31,1.31h4.04
  c0.72,0,1.31-0.59,1.31-1.31v-6.9C15.54,7.41,14.95,6.83,14.23,6.83z M14.27,15.02c0,0.02-0.02,0.03-0.03,0.03l-4.08-0.03L10.2,8.1
  l4.08,0.03v6.89H14.27z"/>
    <path d="M22.24,5.59h-0.2c-0.94,0-1.7,0.76-1.7,1.7l0.01,9.68c0,0.24-0.19,0.43-0.43,0.43h-1.83V5.86
  c0-0.72-0.58-1.3-1.3-1.3H7.64c-0.72,0-1.3,0.58-1.3,1.3v14.5c0,0.01,0.01,0.02,0.01,0.04H5.76c-0.74,0-1.34,0.6-1.34,1.34v2
  c0,0.35,0.28,0.64,0.64,0.64s0.64-0.29,0.64-0.64v-2c0-0.04,0.03-0.07,0.07-0.07h12.89c0.04,0,0.07,0.03,0.07,0.07v2
  c0,0.35,0.28,0.64,0.64,0.64S20,24.09,20,23.74v-2c0-0.74-0.6-1.34-1.34-1.34h-0.58c0-0.01,0.01-0.02,0.01-0.04v-1.68h1.83
  c0.94,0,1.7-0.76,1.7-1.7L21.6,7.29c0-0.24,0.19-0.43,0.43-0.43h0.2c0.24,0,0.43,0.19,0.43,0.43c0,0.35,0.28,0.64,0.64,0.64
  s0.64-0.29,0.64-0.64C23.94,6.36,23.18,5.59,22.24,5.59z M7.64,5.83l9.16,0.03v14.5c0,0.02-0.01,0.03-0.03,0.03l-9.16-0.03
  L7.64,5.83z"/>
  </SvgIcon>
);

export const Education = props => (
  <SvgIcon viewBox="-5 -5 36 36" {...props}>
  <path d="M24.5,17.73V12.5l2.49-1.26L14.19,5.4l-12.8,5.84l6.27,3.17v6.91l0.26,0.19c0.11,0.08,2.68,1.95,6.34,1.95
    s6.13-1.88,6.23-1.96l0.25-0.19v-6.9l2.51-1.27v4.59c-0.68,0.26-1.17,0.91-1.17,1.68c0,0.99,0.81,1.8,1.8,1.8s1.8-0.81,1.8-1.8
    C25.66,18.64,25.18,17.99,24.5,17.73z M14.18,6.79l9.87,4.51l-9.87,5l-9.87-5L14.18,6.79z M19.45,20.66
    c-0.67,0.43-2.62,1.52-5.21,1.52c-2.6,0-4.63-1.1-5.32-1.53v-5.6l5.27,2.67l5.27-2.67v5.61H19.45z M23.86,19.94
    c-0.29,0-0.53-0.24-0.53-0.53s0.24-0.53,0.53-0.53s0.53,0.24,0.53,0.53C24.39,19.7,24.15,19.94,23.86,19.94z"/>
  </SvgIcon>
);

export const Culture = props => (
  <SvgIcon viewBox="-5 -5 36 36" {...props}>
  <g>
    <g>
      <g>
        <path d="M14.21,22.84l-0.26-0.11c-4.21-1.88-6.93-6.62-6.93-12.08V5.44h14.31l-0.01,5.22c0,4.4-1.8,9.89-6.85,12.08
          L14.21,22.84z M8.3,6.71l0.01,3.94c0,3.69,1.56,8.69,5.92,10.8c4.29-2.02,5.83-6.88,5.83-10.8l0.01-3.94
          C20.07,6.71,8.3,6.71,8.3,6.71z"/>
      </g>
      <g>
        <path d="M13.24,9.63c0.07,0.5-0.81,1.42-1.98,1.59C10.09,11.4,9.07,10.76,9,10.26L13.24,9.63z"/>
      </g>
      <g>
        <path d="M19.47,10.26c-0.07,0.5-1.04,1.14-2.21,0.96c-1.18-0.17-2.1-1.09-2.04-1.59L19.47,10.26z"/>
      </g>
      <g>
        <path d="M18.14,15.31c-0.16,1.07-2.15,3.09-3.92,3.09c-1.76,0-3.75-2.01-3.92-3.09c0.84,0.56,2.59,1.54,3.92,1.54
          C15.55,16.85,17.29,15.86,18.14,15.31z"/>
      </g>
    </g>
  </g>
  </SvgIcon>
);

export const Airplane = props => (
  <SvgIcon viewBox="-5 -5 36 36" {...props}>
  <g>
    <g>
      <path d="M20.4,22.11l-3.31-8.1l-0.62-0.62L20,10.33l0.63,0.31l0.16,0.31l0.84,2.94l-0.01,0.01l0.09,0.31l0,0l0.8,2.82
        l0,0l0.66,2.33L20.4,22.11z M18.26,13.51l2.59,6.35l0.88-0.88L21,16.37l0,0l-0.81-2.86l0.01-0.01l-0.38-1.33L18.26,13.51z"/>
    </g>
    <g>
      <path d="M15.3,12.22l-0.62-0.62L6.59,8.3l2.74-2.77l4.92,1.39h-0.01l0.55,0.16l0.01-0.01l2.31,0.65H17.1l0.79,0.22
        l0.63,0.61L15.3,12.22z M8.83,7.84l6.36,2.59l1.36-1.55L9.7,6.95L8.83,7.84z"/>
    </g>
    <g>
      <path d="M11.24,23.55l-2.29-3.29l-0.5-0.5l3.1-2.11l1.05,3.74L11.24,23.55z M10.33,20.01l0.86,1.23l0.03-0.05
        l-0.42-1.5L10.33,20.01z"/>
    </g>
    <g>
      <path d="M8.76,20.07l-0.49-0.5L4.88,17.1l2.19-1.33l3.99,1.29L8.76,20.07z M7.18,17.2l1.4,1.02l0.38-0.49l-1.73-0.56
        L7.18,17.2z"/>
    </g>
    <g>
      <path d="M9.35,20.66l-1.48-1.5l1.89-2.51l0.05,0.02c0.95-1.12,3.93-4.54,8.88-10.22c0.08-0.1,0.93-1.1,2.14-1.17
        C21.3,5.25,22,5.37,22.7,6.08c0.7,0.7,0.81,1.41,0.79,1.87c-0.07,1.18-1.04,2.02-1.19,2.14c-7.27,6.18-9.62,8.16-10.4,8.81
        l0.01,0.05l-0.38,0.3L9.35,20.66z M10.22,18.14l-0.64,0.85l0.85-0.56l-0.01-0.03l0.41-0.29c0.3-0.23,6.52-5.51,10.62-9l0.01-0.01
        c0.19-0.16,0.7-0.69,0.73-1.24c0.02-0.31-0.12-0.6-0.42-0.9s-0.58-0.44-0.9-0.42c-0.55,0.03-1.08,0.53-1.24,0.72
        c-3.55,4.07-8.89,10.21-9.14,10.52L10.22,18.14L10.22,18.14z"/>
    </g>
  </g>
  </SvgIcon>
);

export const Museum = props => (
  <SvgIcon viewBox="-8 -5 36 36" {...props}>
  <g>
    <g>
      <path d="M22.96,22.63H5.84c-0.35,0-0.64-0.29-0.64-0.64s0.28-0.64,0.64-0.64h17.11c0.35,0,0.64,0.29,0.64,0.64
        S23.31,22.63,22.96,22.63z"/>
    </g>
    <g>
      <path d="M22.51,9.77H5.83c-0.3,0-0.55-0.21-0.62-0.49s0.08-0.59,0.34-0.71l8.3-4c0.17-0.08,0.38-0.09,0.55,0l8.38,4
        c0.27,0.13,0.41,0.42,0.35,0.71C23.07,9.56,22.81,9.77,22.51,9.77z M8.62,8.5h11.09l-5.57-2.66L8.62,8.5z"/>
    </g>
    <g>
      <g>
        <path d="M10.12,20.48H7.63C7.28,20.48,7,20.19,7,19.84v-8.56c0-0.35,0.28-0.64,0.64-0.64h2.49
          c0.35,0,0.64,0.29,0.64,0.64v8.56C10.76,20.19,10.48,20.48,10.12,20.48z M8.27,19.2h1.22v-7.29H8.27V19.2z"/>
      </g>
      <g>
        <path d="M15.75,20.48h-2.49c-0.35,0-0.64-0.29-0.64-0.64v-8.56c0-0.35,0.28-0.64,0.64-0.64h2.49
          c0.35,0,0.64,0.29,0.64,0.64v8.56C16.39,20.19,16.1,20.48,15.75,20.48z M13.89,19.2h1.22v-7.29h-1.22V19.2z"/>
      </g>
      <g>
        <path d="M21.38,20.48h-2.49c-0.35,0-0.64-0.29-0.64-0.64v-8.56c0-0.35,0.28-0.64,0.64-0.64h2.49
          c0.35,0,0.64,0.29,0.64,0.64v8.56C22.01,20.19,21.73,20.48,21.38,20.48z M19.52,19.2h1.22v-7.29h-1.22V19.2z"/>
      </g>
    </g>
  </g>
  </SvgIcon>
);

export const Transport = props => (
  <SvgIcon viewBox="-5 -5 36 36" {...props}>
  <path d="M24.89,9.22c0-0.01,0-0.02,0-0.04V8.61h-0.06c-0.27-1.22-1.35-2.14-2.68-2.19h-3.97l0,0h-6.72h-1.27H3.47v6.42
    h0.05v5.2H5.8c-0.01,0.08-0.03,0.16-0.03,0.25c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81c0-0.08-0.02-0.16-0.03-0.25h5.26
    c-0.01,0.08-0.03,0.16-0.03,0.25c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81c0-0.08-0.02-0.16-0.03-0.25h2.65v-5.2h0.05V9.22
    H24.89z M22.08,7.69c0.83,0,1.52,0.67,1.53,1.5v2.37h-5.44V7.69H22.08z M11.46,7.69h5.44v3.87h-5.44
    C11.46,11.56,11.46,7.69,11.46,7.69z M4.74,7.69h5.44v3.87H4.74V7.69z M8.58,19.81c-0.85,0-1.53-0.69-1.53-1.54
    c0-0.2,0.04-0.4,0.11-0.57l0.02-0.05c0.06-0.13,0.13-0.24,0.22-0.35c0.01-0.02,0.03-0.03,0.04-0.05c0.09-0.1,0.19-0.19,0.3-0.27
    c0.01,0,0.01-0.01,0.02-0.01c0.1-0.07,0.22-0.12,0.34-0.16c0.03-0.01,0.06-0.02,0.09-0.03c0.13-0.03,0.26-0.06,0.4-0.06
    c0.14,0,0.27,0.02,0.4,0.06c0.03,0.01,0.06,0.02,0.09,0.03c0.12,0.04,0.23,0.09,0.34,0.16c0,0,0.01,0,0.01,0.01
    c0.11,0.07,0.22,0.17,0.31,0.27c0.01,0.01,0.02,0.03,0.04,0.04c0.09,0.1,0.16,0.22,0.22,0.35l0,0.07c0.07,0.18,0.11,0.37,0.11,0.57
    C10.11,19.12,9.43,19.81,8.58,19.81z M19.4,19.81c-0.85,0-1.53-0.69-1.53-1.54c0-0.2,0.04-0.4,0.11-0.57L18,17.65
    c0.06-0.13,0.13-0.24,0.22-0.35c0.01-0.02,0.03-0.03,0.04-0.05c0.09-0.1,0.19-0.19,0.3-0.27c0.01,0,0.01-0.01,0.02-0.01
    c0.1-0.07,0.22-0.12,0.34-0.16c0.03-0.01,0.06-0.02,0.09-0.03c0.13-0.03,0.26-0.06,0.4-0.06s0.27,0.02,0.4,0.06
    c0.03,0.01,0.06,0.02,0.09,0.03c0.12,0.04,0.23,0.09,0.34,0.16c0,0,0.01,0,0.01,0.01c0.11,0.07,0.22,0.17,0.31,0.27
    c0.01,0.01,0.02,0.03,0.04,0.04c0.09,0.1,0.16,0.22,0.22,0.35l0.02,0.05c0.07,0.18,0.11,0.37,0.11,0.57
    C20.94,19.12,20.25,19.81,19.4,19.81z M23.56,16.76h-1.81c0,0,0,0-0.01-0.01c-0.12-0.18-0.26-0.35-0.42-0.5
    c-0.03-0.03-0.06-0.05-0.1-0.08c-0.13-0.11-0.27-0.21-0.42-0.3c-0.05-0.03-0.1-0.06-0.16-0.09c-0.14-0.07-0.29-0.13-0.44-0.18
    c-0.06-0.02-0.11-0.04-0.17-0.05c-0.21-0.05-0.42-0.08-0.65-0.08s-0.44,0.03-0.65,0.08c-0.06,0.01-0.11,0.03-0.17,0.05
    c-0.15,0.05-0.3,0.1-0.44,0.18c-0.06,0.03-0.11,0.06-0.16,0.09c-0.15,0.09-0.28,0.19-0.41,0.3c-0.03,0.03-0.07,0.05-0.1,0.08
    c-0.16,0.15-0.3,0.32-0.42,0.5c0,0,0,0-0.01,0.01H10.9c0,0,0,0-0.01-0.01c-0.12-0.18-0.26-0.35-0.42-0.5
    c-0.03-0.03-0.06-0.05-0.1-0.08c-0.13-0.11-0.27-0.21-0.42-0.3c-0.05-0.03-0.1-0.06-0.16-0.09c-0.14-0.07-0.29-0.13-0.44-0.18
    c-0.06-0.02-0.11-0.04-0.17-0.05c-0.21-0.05-0.42-0.08-0.65-0.08c-0.22,0-0.44,0.03-0.65,0.08c-0.06,0.01-0.11,0.03-0.17,0.05
    c-0.15,0.05-0.3,0.1-0.44,0.18c-0.05,0.03-0.11,0.06-0.16,0.09c-0.15,0.09-0.29,0.19-0.41,0.3c-0.03,0.03-0.07,0.05-0.1,0.08
    c-0.16,0.15-0.3,0.32-0.42,0.5c0,0,0,0-0.01,0.01H4.8v-3.87h18.77v3.87H23.56z"/>
  </SvgIcon>
);

export const Skiing = props => (
  <SvgIcon viewBox="-5 -5 36 36" {...props}>
  <path d="M4.57,24.46c-0.07,0-0.14-0.01-0.21-0.03l-0.51-0.17l-0.51-0.23c-0.1-0.04-0.18-0.11-0.25-0.19
    c-0.34-0.43-0.51-0.66-0.51-0.99c0-0.37,0.3-0.67,0.67-0.67c0.31,0,0.57,0.21,0.65,0.5c0.03,0.05,0.09,0.12,0.15,0.2l0.62,0.24
    c0.28-0.01,0.54-0.03,0.77-0.08c0.26-0.03,0.42-0.1,0.59-0.18l7.79-3.79l-4.16-3.03c-0.51-0.41-0.78-0.98-0.78-1.62v-0.1
    c0.01-0.14,0.03-0.27,0.06-0.4l-3.08,1.72c-0.23,0.14-1.01,0.41-1.67,0.18c-0.37-0.13-0.66-0.4-0.8-0.76
    C3,14.08,3.7,13.17,4.55,12.7l2.68-1.52c-0.25-0.12-0.51-0.26-0.74-0.43c-1,0.67-2.47,0.53-3.35-0.34
    c-0.53-0.53-0.8-1.17-0.8-1.89c0-0.73,0.27-1.39,0.77-1.89c0.52-0.52,1.09-0.78,1.85-0.85C5.73,5.71,6.64,6.06,7.12,6.6
    c0.23,0.25,0.37,0.53,0.46,0.8c1.42-0.78,3.25-1.12,5.17-0.96c1.67,0.14,2.81,0.44,3.79,1.02l4.99-2.43
    c0.33-0.16,0.73-0.02,0.89,0.31c0.16,0.33,0.02,0.73-0.31,0.89l-4.4,2.14l0.11,0.1c0.58,0.71,0.82,1.37,0.82,2.08
    c0,0.85-0.35,2.05-2.01,2.96l-2.09,1.16l2.53,1.85c0.23,0.16,0.42,0.38,0.57,0.68l6.77-3.29c0.33-0.16,0.73-0.02,0.89,0.31
    c0.16,0.33,0.02,0.73-0.31,0.89L6.63,24.05c-0.25,0.12-0.56,0.25-0.96,0.3C5.38,24.42,4.99,24.46,4.57,24.46z M15.41,11.16
    c0,0-0.01,0.01-0.01,0.01l-4.84,2.68c-0.23,0.13-0.32,0.25-0.33,0.51l0,0.06c0,0.24,0.08,0.42,0.26,0.56l4.58,3.33
    c0.04,0.03,0.08,0.06,0.11,0.1l1.29-0.63c-0.05-0.11-0.1-0.15-0.14-0.17l-3.41-2.49c-0.18-0.13-0.29-0.35-0.27-0.58
    c0.01-0.23,0.14-0.43,0.34-0.54c0.16-0.09,0.32-0.17,0.47-0.25L16,12.34c0.87-0.48,1.31-1.08,1.31-1.79
    c0-0.41-0.14-0.77-0.46-1.18l-0.44-0.4c-0.07-0.06-0.15-0.11-0.22-0.17c-0.04-0.02-0.09-0.05-0.12-0.08
    c-0.71-0.47-1.64-0.8-3.43-0.96C10.59,7.6,9.53,7.66,7.98,8.66c0,0-0.52,0.36-0.52,0.36C7.34,9.06,6.91,9.05,6.68,8.76
    C6.55,8.59,6.69,8.29,6.56,8.02c0.01-0.14-0.19-0.49-0.41-0.65C5.91,7.18,5.42,7.09,5.08,7.11C4.64,7.15,4.36,7.28,4.06,7.57
    C3.81,7.83,3.69,8.14,3.69,8.52c0,0.36,0.13,0.67,0.41,0.95c0.26,0.26,0.57,0.38,0.95,0.38c0.4,0,0.7-0.04,0.97-0.34
    c0.13-0.14,0.26-0.24,0.45-0.24c0.19,0.01,0.27,0.09,0.5,0.23c0.29,0.17,0.86,0.49,1.29,0.69c0.31,0.14,0.58,0.27,0.77,0.41
    c0.19,0.13,0.3,0.35,0.29,0.58c-0.01,0.23-0.14,0.44-0.34,0.55L5.2,13.87c-0.23,0.12-0.66,0.46-0.57,0.7
    c0.07,0.03,0.42-0.03,0.58-0.1l5.08-2.83c0.32-0.17,0.35-0.36,0.34-0.51c-0.03-0.13-0.36-0.44-0.55-0.56
    c-0.21-0.1-0.35-0.3-0.38-0.54C9.66,9.68,9.9,9.37,10.24,9.3c1.59-0.28,2.29-0.39,3.6-0.12c0.74,0.15,1.32,0.44,1.77,0.89
    c0.19,0.19,0.25,0.48,0.15,0.73C15.69,10.97,15.57,11.1,15.41,11.16z M11.75,10.41c0.11,0.2,0.19,0.4,0.2,0.6
    c0.02,0.19,0,0.38-0.04,0.56l1.86-1.03c-0.06-0.02-0.13-0.03-0.2-0.05C12.88,10.35,12.42,10.33,11.75,10.41z M6.63,8.04L6.63,8.04
    L6.63,8.04z"/>
  </SvgIcon>
);

export const Store = props => (
  <SvgIcon viewBox="-5 -5 36 36" {...props}>
	<path d="M9.01,19.13C7.9,19.13,7,20.03,7,21.14s0.9,2.01,2.01,2.01s2.01-0.9,2.01-2.01
		C11.02,20.03,10.12,19.13,9.01,19.13z M9.01,21.87c-0.41,0-0.73-0.33-0.73-0.73s0.33-0.74,0.73-0.74s0.73,0.33,0.73,0.74
		S9.42,21.87,9.01,21.87z"/>
	<path d="M18.26,19.13c-1.11,0-2.01,0.9-2.01,2.01s0.9,2.01,2.01,2.01s2.01-0.9,2.01-2.01
		C20.27,20.03,19.37,19.13,18.26,19.13z M18.26,21.87c-0.4,0-0.73-0.33-0.73-0.73s0.33-0.74,0.73-0.74c0.41,0,0.73,0.33,0.73,0.74
		S18.67,21.87,18.26,21.87z"/>
	<path d="M25.12,4.74H21.6l-1.16,4.8H4.38l2.99,9.49h11.58c0.31,0,0.55-0.22,0.61-0.52c0-0.01,0-0.01,0.01-0.01
		l3.02-12.49h2.52c0.35,0,0.64-0.29,0.64-0.64S25.47,4.74,25.12,4.74z M6.11,10.81h14.01l-1.68,6.95H8.3L6.11,10.81z"/>
  </SvgIcon>
);

export const Place = props => (
  <SvgIcon viewBox="-5 0 36 36" {...props}>
    <path fill="#666" d="M27.236 25.683h-18.641l-0.207-5.074h2.589v-6.628h1.346v-3.521l2.175-1.864 2.175 1.968v3.521h1.45v6.628h2.382v-4.764l1.761-1.553 1.864 1.553v2.485h3.003v7.249zM9.735 24.44h16.259v-4.764h-3.003v-3.107l-0.621-0.518-0.518 0.518v5.385h-4.867v-6.628h-1.45v-4.246l-1.036-0.828-0.932 0.828v4.246h-1.346v6.628h-2.589l0.104 2.485z"></path>
    <path fill="#666" d="M13.877 7.042h1.243v2.485h-1.243v-2.485z"></path>
  </SvgIcon>
);

export const Mountain = props => (
  <SvgIcon viewBox="-5 -2 36 36" {...props}>
    <polygon points="21.2,12.1 21.2,12 18.9,16.2 14.3,8.4 14.3,8.4 6.7,21.3 6.7,21.4 6.8,21.4 8.2,21.4 14.3,10.9 
  20.4,21.4 20.4,21.4 21.8,21.4 21.8,21.4 21.9,21.4 19.6,17.4 21.3,14.3 24.7,19.2 24.7,19.3 26.2,19.3 "/>
  </SvgIcon>
);

export const River = props => (
  <SvgIcon viewBox="-2 -2 33.3 30.9" {...props}>
    <path d="M25.7,17.8c-1.1,0-1.7-0.7-2.2-1.2c-0.4-0.5-0.7-0.8-1.2-0.8s-0.8,0.3-1.2,0.8c-0.5,0.5-1,1.2-2.2,1.2
      c-1.1,0-1.7-0.7-2.1-1.2s-0.7-0.8-1.2-0.8s-0.8,0.3-1.2,0.8c-0.5,0.5-1,1.2-2.1,1.2s-1.7-0.7-2.1-1.2c-0.4-0.5-0.7-0.8-1.2-0.8
      v-1.2c1.1,0,1.7,0.7,2.1,1.2c0.4,0.5,0.7,0.8,1.2,0.8s0.8-0.3,1.2-0.8c0.5-0.5,1-1.2,2.1-1.2s1.7,0.7,2.1,1.2
      c0.4,0.5,0.7,0.8,1.2,0.8s0.8-0.3,1.2-0.8c0.5-0.5,1-1.2,2.2-1.2s1.7,0.7,2.2,1.2c0.4,0.5,0.7,0.8,1.2,0.8V17.8z"/>
  </SvgIcon>
);

export const Hotel = props => (
  <SvgIcon viewBox="-5 0 36 36"  {...props}>
    <path fill="#666" d="M26.822 21.126h-18.019v-4.66h18.019v4.66zM10.045 19.884h15.534v-2.278h-15.534v2.278z"></path>
    <path fill="#666" d="M8.803 20.505h1.243v2.589h-1.243v-2.589z"></path>
    <path fill="#666" d="M8.803 9.735h1.243v7.249h-1.243v-7.249z"></path>
    <path fill="#666" d="M25.579 16.984h1.243v6.11h-1.243v-6.11z"></path>
    <path fill="#666" d="M15.534 15.638h-2.382c-1.45 0-2.589-0.828-2.589-1.968s1.139-1.968 2.589-1.968h2.382c1.45 0 2.589 0.828 2.589 1.968s-1.139 1.968-2.589 1.968zM13.152 13.049c-0.828 0-1.346 0.414-1.346 0.725s0.518 0.725 1.346 0.725h2.382c0.828 0 1.346-0.414 1.346-0.725s-0.518-0.725-1.346-0.725h-2.382z"></path>
  </SvgIcon>
);

export const Street = props => (
  <SvgIcon viewBox="-12 -10 42 42" {...props}>
  <polyline points="12.4,13.3 9.7,13.3 9.6,17 12.5,17 12.4,14.1 			"/>
  <path d="M12.1,6.3H10l-0.2,4h2.4L12.1,6.3 M11.9,0.2h-1.8L10,3.6h2L11.9,0.2"/>
  <polyline points="6.4,0.1 4.8,0.1 0,17 2.9,17 6.4,0.1 			"/>
  <polyline points="17.1,0.1 15.5,0.1 19,17 21.9,17 17.1,0.1 			"/>
  </SvgIcon>
);

export const Public = props => (
  <SvgIcon viewBox="-8 -5 36 36" {...props}>
	<path d="M18.9,22.9H1.7c-0.4,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h17.1c0.4,0,0.6-0.3,0.6-0.6S19.2,22.9,18.9,22.9z"/>
	<path d="M1.7,11.4h16.7c0.3,0,0.6-0.2,0.6-0.5c0.1-0.3-0.1-0.6-0.3-0.7l-8.1-3.9V4.8h4.6V0.5H9.3v2.3v2v1.6l-7.9,3.8
		c-0.3,0.1-0.4,0.4-0.3,0.7S1.4,11.4,1.7,11.4z M10.6,1.8h3.3v1.8h-3.3V2.8V1.8z M10,7.5l5.6,2.7H4.5L10,7.5z"/>
	<path d="M3.5,12.2c-0.4,0-0.6,0.3-0.6,0.6v8.6c0,0.4,0.3,0.6,0.6,0.6H6c0.4,0,0.6-0.3,0.6-0.6v-8.6
		c0-0.4-0.3-0.6-0.6-0.6H3.5z M5.4,20.7H4.2v-7.3h1.2V20.7z"/>
	<path d="M14.8,12.2c-0.4,0-0.6,0.3-0.6,0.6v8.6c0,0.4,0.3,0.6,0.6,0.6h2.5c0.4,0,0.6-0.3,0.6-0.6v-8.6
		c0-0.4-0.3-0.6-0.6-0.6H14.8z M16.6,20.7h-1.2v-7.3h1.2V20.7z"/>
  </SvgIcon>
);

export const Sport = props => (
  <SvgIcon viewBox="-8 -8 32 32" {...props}>
  <path d="M17.7,11.9c0.7-2.1,0.5-4.4-0.6-6.5c-0.3-0.5-0.6-0.9-0.9-1.3C16.1,4,16,4,16,3.9c-1-1.1-2.3-2-3.8-2.4
    c-1.9-0.6-4-0.4-5.8,0.4c0,0-0.1,0-0.1,0C6.2,1.9,6.1,2,6.1,2C6,2.1,5.9,2.1,5.8,2.2C3.9,3.2,2.5,5,1.9,7.1
    c-0.6,2.1-0.4,4.4,0.7,6.3c0.6,1.1,1.5,2.1,2.5,2.8c0.1,0.2,0.3,0.3,0.5,0.3c0,0,0,0,0,0c0.6,0.3,1.2,0.6,1.9,0.8
    c0.8,0.2,1.6,0.3,2.3,0.3c0.9,0,1.8-0.2,2.7-0.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.4-0.1,0.8-0.3,1.1-0.5c1.9-1,3.2-2.7,3.8-4.6
    C17.6,12,17.7,12,17.7,11.9C17.7,11.9,17.7,11.9,17.7,11.9z M16.6,11c-2.2-0.7-4.2-1.9-5.9-3.5c1.4-1.2,3-2,4.6-2.4
    c0.2,0.3,0.4,0.6,0.6,0.9C16.8,7.6,17,9.4,16.6,11z M9.8,2.4c0.7,0,1.3,0.1,2,0.3c1,0.3,1.8,0.8,2.6,1.4c-1.6,0.5-3.1,1.3-4.5,2.5
    C9,5.7,8.4,4.7,7.8,3.7C7.6,3.4,7.5,3.1,7.4,2.9C8.2,2.6,9,2.4,9.8,2.4z M6.2,3.4C6.4,3.7,6.5,4,6.7,4.3C7.3,5.4,8,6.5,8.9,7.4
    C8.5,7.8,8.1,8.2,7.7,8.7c-1.2-1-2.6-1.9-4.1-2.5C4.2,5,5.1,4.1,6.2,3.4z M3.7,12.8c-0.9-1.6-1.1-3.5-0.6-5.3c0,0,0-0.1,0-0.1
    C4.5,8,5.8,8.8,7,9.7c-0.9,1.4-1.6,3-1.9,4.9C4.5,14.1,4,13.5,3.7,12.8z M7.8,16.1c-0.5-0.2-1-0.4-1.5-0.7C6.5,13.7,7.1,12,8,10.6
    c1.1,1,2,2.2,2.7,3.6c0.3,0.6,0.6,1.3,0.9,2C10.3,16.5,9.1,16.5,7.8,16.1z M13.2,15.5c-0.1,0.1-0.3,0.1-0.4,0.2
    c-0.3-0.7-0.6-1.5-1-2.2c-0.8-1.5-1.9-2.8-3.1-4C9,9.1,9.4,8.7,9.8,8.4c1.8,1.7,4,3,6.4,3.8C15.6,13.6,14.6,14.8,13.2,15.5z"/>
  </SvgIcon>
);

export const Health = props => (
  <SvgIcon viewBox="-8 -8 32 32" {...props}>
	<path d="M10,16.2H6.6c-0.8,0-1.5-0.7-1.5-1.5v-3.1H2c-0.8,0-1.5-0.7-1.5-1.5V6.7c0-0.8,0.7-1.5,1.5-1.5h3.1V2.1
		c0-0.8,0.7-1.5,1.5-1.5H10c0.8,0,1.5,0.7,1.5,1.5v3.1h3.1c0.8,0,1.5,0.7,1.5,1.5v3.4c0,0.8-0.7,1.5-1.5,1.5h-3.1v3.1
		C11.5,15.5,10.8,16.2,10,16.2z M2,6.5c-0.1,0-0.2,0.1-0.2,0.2v3.4c0,0.1,0.1,0.2,0.2,0.2h3.8c0.4,0,0.7,0.3,0.7,0.7v3.8
		c0,0.1,0.1,0.2,0.2,0.2H10c0.1,0,0.2-0.1,0.2-0.2v-3.8c0-0.4,0.3-0.7,0.7-0.7h3.8c0.1,0,0.2-0.1,0.2-0.2V6.7c0-0.1-0.1-0.2-0.2-0.2
		h-3.8c-0.4,0-0.7-0.3-0.7-0.7V2.1c0-0.1-0.1-0.2-0.2-0.2H6.6C6.5,1.9,6.4,2,6.4,2.1v3.8c0,0.4-0.3,0.7-0.7,0.7H2z"/>
  </SvgIcon>
);

export const Finance = props => (
  <SvgIcon viewBox="-8 -8 32 32" {...props}>
	<path d="M17.7,1.4h-12H1V6v8.7h0h4h12.7h4.6h0V6V1.4H17.7z M21.2,2.7v2c-1-0.2-1.8-1-2.1-2H21.2z M17.8,2.7
		c0.3,1.7,1.7,3,3.4,3.3v4.2c-1.7,0.3-3.1,1.6-3.3,3.4H5.6c-0.3-1.7-1.6-3.1-3.3-3.4V6C4,5.7,5.3,4.4,5.6,2.7H17.8z M2.3,2.7h2.1
		c-0.3,1-1.1,1.8-2.1,2V2.7z M2.3,13.5v-2.1c1,0.3,1.8,1.1,2,2.1H2.3z M19.1,13.5c0.2-1,1-1.8,2-2.1v2.1H19.1z"/>
	<path d="M8.8,9.2h0.8c0.1,0.6,0.4,1.1,0.8,1.5c0.6,0.6,1.5,0.9,2.4,0.9c0.8,0,1.5-0.2,1.8-0.4l-0.2-1.1
		c-0.3,0.2-0.8,0.3-1.4,0.3c-0.6,0-1.1-0.2-1.5-0.5c-0.2-0.2-0.3-0.4-0.4-0.7h2.9V8.4h-3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3h3V7
		h-2.9c0.1-0.3,0.2-0.5,0.4-0.7C12,5.9,12.5,5.7,13,5.7c0.6,0,1,0.1,1.2,0.3l0.3-1.1c-0.3-0.2-0.9-0.3-1.6-0.3c-0.9,0-1.9,0.3-2.5,1
		C10.1,5.9,9.8,6.4,9.7,7H8.8v0.7h0.7c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3H8.8V9.2z"/>
  </SvgIcon>
);

export const Catering = props => (
  <SvgIcon viewBox="-8 -8 32 32" {...props}>
  <path d="M10.9,7l0.3,0.3c0.4,0.4,1,0.7,1.6,0.7s1.2-0.2,1.6-0.7L17,4.7l-0.9-0.9l-2.5,2.5c-0.4,0.4-1,0.4-1.4,0
    l-0.3-0.3l3.4-3.4l-0.9-0.9l-3.4,3.4l-0.2-0.2c-0.4-0.4-0.4-1,0-1.4l2.5-2.5L12.2,0L9.7,2.6C9.3,3,9,3.6,9,4.2s0.2,1.2,0.7,1.6
    L10,6.1L8.5,7.5L1.7,0.7L1.2,1.2C0.8,1.7,0.1,2.9,1,4.1c0.8,1,2.8,3.2,2.9,3.4c0.5,0.5,1.7,1.1,3,0.3l0.7,0.7l-6.4,6.4l0.9,0.9
    l6.4-6.4l6.4,6.4l0.9-0.9L9.4,8.4L10.9,7z M4.8,6.5c0,0-2.1-2.3-2.8-3.3C1.8,3.1,1.8,2.9,1.8,2.7l4.1,4.1C5.3,7,4.9,6.6,4.8,6.5z"/>
  </SvgIcon>
);

export const Copyrights = props => (
  <SvgIcon viewBox="-8 -8 32 32" {...props}>
  <path d="M21.6,32.1c-6.8,0-12.4-5.5-12.4-12.4S14.8,7.4,21.6,7.4c6.8,0,12.4,5.5,12.4,12.4S28.4,32.1,21.6,32.1z
     M21.6,9.4c-5.7,0-10.4,4.7-10.4,10.4s4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4S27.3,9.4,21.6,9.4z"/>
  <path d="M25.2,25.9c-0.7,0.3-2,0.6-3.5,0.6c-3.9,0-6.4-2.5-6.4-6.3c0-3.7,2.5-6.6,6.9-6.6c1.1,0,2.3,0.3,3,0.6
    l-0.6,2.3c-0.5-0.2-1.2-0.5-2.4-0.5c-2.4,0-3.8,1.8-3.8,4c0,2.5,1.7,4,3.8,4c1.1,0,1.9-0.2,2.5-0.5L25.2,25.9z"/>
  </SvgIcon>
);

export const Routing = props => (
  <SvgIcon viewBox="-2 -2 36 36" {...props}>
    <g>
      <g>
        <path d="M17.5,27.7l-0.5-0.7c-0.5-0.6-4.5-6.1-4.5-8.7c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5c0,2.6-4,8.1-4.5,8.7
          L17.5,27.7z M17.5,14.6c-2.1,0-3.7,1.7-3.7,3.7c0,1.6,2.4,5.3,3.7,7.2c1.4-2,3.7-5.6,3.7-7.2C21.2,16.3,19.5,14.6,17.5,14.6z"/>
      </g>
      <g>
        <path d="M26.1,19.5l-0.5-0.7c-0.5-0.7-2.9-4-2.9-5.6c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4
          c0,1.7-2.4,5-2.9,5.6L26.1,19.5z M26.1,11c-1.2,0-2.1,1-2.1,2.1c0,0.8,1.2,2.8,2.1,4.2c1-1.4,2.1-3.4,2.1-4.2
          C28.2,11.9,27.2,11,26.1,11z"/>
      </g>
      <g>
        <path d="M30.2,27.8H19.3v-1.3h10.8c0.5,0,0.9-0.4,0.9-0.9v-0.2c0-0.5-0.4-0.9-0.9-0.9h-5c-1.2,0-2.2-0.9-2.2-2
          s1-2,2.2-2h5c0.6,0,0.9-0.3,0.9-0.4s-0.3-0.4-0.9-0.4h-2.7v-1.3h2.7c1.2,0,2.2,0.7,2.2,1.7c0,0.9-1,1.7-2.2,1.7h-5
          c-0.5,0-0.9,0.3-0.9,0.8s0.4,0.8,0.9,0.8h5c1.2,0,2.2,1,2.2,2.2v0.2C32.4,26.8,31.4,27.8,30.2,27.8z"/>
      </g>
    </g>
  </SvgIcon>
);

export const Search = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path fill="#666" d="M23.303 21.497l0.656-0.656-4.513-4.431c0.574-0.738 0.903-1.641 0.903-2.626 0-2.297-1.805-4.103-4.103-4.103s-4.103 1.805-4.103 4.103c0 2.297 1.805 4.103 4.103 4.103 0.985 0 1.887-0.328 2.626-0.903l4.431 4.513zM16.246 10.585c1.805 0 3.282 1.477 3.282 3.282s-1.477 3.282-3.282 3.282c-1.805 0-3.282-1.477-3.282-3.282s1.477-3.282 3.282-3.282z"></path>
  </SvgIcon>
);

export const Traffic = props => (
  <SvgIcon viewBox="-1 -2 36 36" {...props}>
     <path d="M27.569 21.662h-5.579c-0.328 0-0.656-0.328-0.656-0.656s0.328-0.656 0.656-0.656h5.005c0-0.164 0-0.246 0-0.41 0-5.087-4.103-9.19-9.19-9.19s-9.19 4.103-9.19 9.19c0 0.164 0 0.246 0 0.41h4.923c0.328 0 0.656 0.328 0.656 0.656s-0.328 0.656-0.656 0.656h-5.662c-0.328 0-0.656-0.246-0.656-0.574s-0.082-0.738-0.082-1.067c0-5.826 4.759-10.503 10.503-10.503s10.503 4.759 10.503 10.503c0 0.328 0 0.738-0.082 1.067 0.082 0.246-0.164 0.574-0.492 0.574z"></path>
    <path d="M17.887 22.892c-0.574 0-1.149-0.246-1.559-0.574-0.492-0.41-0.738-0.985-0.82-1.641 0-0.656 0.164-1.231 0.574-1.723s0.985-0.738 1.641-0.82c0 0 0 0 0 0 1.313-0.082 2.38 0.903 2.462 2.215 0 0.656-0.164 1.231-0.574 1.723s-0.985 0.738-1.641 0.82c0 0 0 0-0.082 0zM17.805 19.528c-0.246 0-0.492 0.164-0.738 0.328-0.164 0.246-0.246 0.492-0.246 0.738s0.164 0.492 0.328 0.738c0.246 0.164 0.492 0.246 0.738 0.246s0.492-0.164 0.738-0.328c0.164-0.246 0.246-0.492 0.246-0.738 0-0.574-0.492-0.985-1.067-0.985v0z"></path>
    <path d="M17.067 19.774c-0.246 0-0.41-0.082-0.574-0.328l-3.2-5.579c-0.164-0.328-0.082-0.738 0.246-0.903s0.738-0.082 0.903 0.246l3.2 5.579c0.164 0.328 0.082 0.738-0.246 0.903-0.082 0.082-0.246 0.082-0.328 0.082z"></path>
    <path d="M17.641 14.523c-0.328 0-0.656-0.328-0.656-0.656v-1.969c0-0.328 0.328-0.656 0.656-0.656s0.656 0.328 0.656 0.656v1.969c-0.082 0.328-0.328 0.656-0.656 0.656z"></path>
    <path d="M12.144 17.641c-0.082 0-0.246 0-0.328-0.082l-1.723-0.985c-0.328-0.164-0.41-0.574-0.246-0.903s0.574-0.41 0.903-0.246l1.723 0.985c0.328 0.164 0.41 0.574 0.246 0.903-0.164 0.246-0.328 0.328-0.574 0.328z"></path>
    <path d="M23.056 17.641c-0.246 0-0.41-0.082-0.574-0.328-0.164-0.328-0.082-0.738 0.246-0.903l1.723-0.985c0.328-0.164 0.738-0.082 0.903 0.246s0.082 0.738-0.246 0.903l-1.723 0.985c-0.082 0.082-0.246 0.082-0.328 0.082z"></path>
    <path d="M20.759 15.344c-0.082 0-0.246 0-0.328-0.082-0.328-0.164-0.41-0.574-0.246-0.903l0.985-1.723c0.164-0.328 0.574-0.41 0.903-0.246s0.41 0.574 0.246 0.903l-0.985 1.723c-0.164 0.246-0.328 0.328-0.574 0.328z"></path>
  </SvgIcon>
);

export const More = props => (
  <SvgIcon viewBox="-2 -3 38 38" {...props}>
    <path d="M12.964 16.164c0-1.641-1.313-2.954-2.954-2.954s-2.954 1.313-2.954 2.954 1.313 2.954 2.954 2.954 2.954-1.313 2.954-2.954zM8.451 16.164c0-0.903 0.738-1.559 1.559-1.559 0.903 0 1.559 0.738 1.559 1.559s-0.738 1.559-1.559 1.559c-0.82 0-1.559-0.656-1.559-1.559z"></path>
    <path d="M20.677 16.164c0-1.641-1.313-2.954-2.954-2.954s-2.954 1.313-2.954 2.954 1.313 2.954 2.954 2.954 2.954-1.313 2.954-2.954zM16.164 16.164c0-0.903 0.738-1.559 1.559-1.559 0.903 0 1.559 0.738 1.559 1.559s-0.738 1.559-1.559 1.559c-0.82 0-1.559-0.656-1.559-1.559z"></path>
    <path d="M25.436 13.21c-1.641 0-2.954 1.313-2.954 2.954s1.313 2.954 2.954 2.954 2.954-1.313 2.954-2.954-1.313-2.954-2.954-2.954zM25.436 17.723c-0.903 0-1.559-0.738-1.559-1.559s0.738-1.559 1.559-1.559c0.903 0 1.559 0.738 1.559 1.559s-0.656 1.559-1.559 1.559z"></path>
  </SvgIcon>
);

export const TrafficJam = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path d="M23.301 21.644c-0.311 0-0.518-0.207-0.518-0.518v-5.592l-2.693-4.453h-4.039c-0.311 0-0.518-0.207-0.518-0.518s0.207-0.518 0.518-0.518h4.349c0.207 0 0.311 0.104 0.414 0.207l2.9 4.764c0 0.104 0.104 0.207 0.104 0.311v5.799c0 0.311-0.207 0.518-0.518 0.518z"></path>
    <path d="M25.476 20.505c-0.311 0-0.518-0.207-0.518-0.518v-5.385l-3.21-5.074h-3.521c-0.311 0-0.518-0.207-0.518-0.518s0.207-0.518 0.518-0.518h3.728c0.207 0 0.311 0.104 0.414 0.207l3.417 5.385c0.104 0.104 0.104 0.207 0.104 0.311v5.592c0.104 0.311-0.104 0.518-0.414 0.518z"></path>
    <path d="M21.23 22.887h-2.175c-0.311 0-0.518-0.207-0.518-0.518v-1.243h-6.214v1.243c0 0.311-0.207 0.518-0.518 0.518h-2.071c-0.311 0-0.518-0.207-0.518-0.518v-5.903c0-0.104 0-0.207 0.104-0.207l2.382-4.039c0.104-0.207 0.311-0.207 0.414-0.207h6.835c0.207 0 0.311 0.104 0.414 0.207l2.382 4.039c0 0.104 0.104 0.207 0.104 0.207v5.903c-0.104 0.311-0.414 0.518-0.621 0.518zM19.573 21.851h1.139v-5.282l-2.071-3.728h-6.214l-2.071 3.728v5.282h1.139v-1.139c0-0.311 0.207-0.518 0.518-0.518h7.249c0.311 0 0.518 0.207 0.518 0.518v1.139z"></path>
    <path d="M17.191 19.159h-3.21c-0.311 0-0.518-0.207-0.518-0.518s0.207-0.518 0.518-0.518h3.21c0.311 0 0.518 0.207 0.518 0.518 0 0.207-0.207 0.518-0.518 0.518z"></path>
    <path d="M12.427 18.434c0 0.414-0.311 0.725-0.725 0.725s-0.725-0.311-0.725-0.725c0-0.414 0.311-0.725 0.725-0.725s0.725 0.311 0.725 0.725z"></path>
    <path d="M19.987 18.537c0 0.414-0.311 0.725-0.725 0.725s-0.725-0.311-0.725-0.725c0-0.414 0.311-0.725 0.725-0.725s0.725 0.311 0.725 0.725z"></path>
  </SvgIcon>
);

export const Share = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path d="M20.505 20.194h-10.977v-4.453h2.589v-1.243h-3.832v6.939h12.22z"></path>
    <path d="M26.615 14.602l-6.524-4.867v2.278c-0.621 0-1.553 0.104-2.589 0.518-1.657 0.621-3.935 1.968-5.592 5.385l-0.828 1.761 1.657-0.932c2.796-1.45 6.006-1.553 7.249-1.553v2.382l6.628-4.971zM19.676 15.845c-1.243 0-3.417 0.104-5.696 0.932 2.693-3.832 6.421-3.521 6.628-3.417l0.725 0.104v-1.139l3.107 2.278-3.107 2.278v-0.932l-0.621-0.104c0 0-0.414 0-1.036 0z"></path>
  </SvgIcon>
);

export const ReportBugs = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path d="M17.191 8.388c-5.178 0-9.32 3.003-9.32 6.628 0 1.45 0.621 2.9 1.864 4.039-0.104 1.036-0.207 2.589-0.207 2.589l-0.104 1.139 1.036-0.621c0.414-0.311 1.553-1.036 2.071-1.346 1.346 0.518 3.003 0.828 4.557 0.828 5.178 0 9.32-3.003 9.32-6.628s-4.039-6.628-9.217-6.628zM17.191 20.401c-1.553 0-3.107-0.311-4.349-0.828l-0.207-0.104-0.207 0.104c-0.311 0.104-0.932 0.518-1.45 0.828 0-0.518 0.104-1.139 0.104-1.657v-0.311l-0.207-0.207c-1.139-0.932-1.657-2.071-1.657-3.314 0-3.003 3.625-5.385 8.078-5.385s8.078 2.485 8.078 5.385-3.625 5.489-8.181 5.489z"></path>
    <path d="M11.806 12.841h10.667v1.139h-10.667v-1.139z"></path>
    <path d="M11.806 15.12h6.317v1.139h-6.317v-1.139z"></path>
    <path d="M19.366 15.12h1.139v1.139h-1.139v-1.139z"></path>
  </SvgIcon>
);

export const SpeedCamera = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <g>
      <path fill={props.static ? '#00000' : '#A30809'} d="M32.1,17.7c0-6.1-4.9-11-11-11s-11,4.9-11,11c0,4.8,3.1,8.9,7.4,10.4l0,0l3.6,4.2l3.6-4.2l0,0
        C29,26.6,32.1,22.5,32.1,17.7z"/>
      <g>
        <rect fill="#fff" x="23.7" y="15.5" width="1.5" height="7.4"/>
        <rect fill="#fff" x="26" y="17.6" width="1.8" height="5.3"/>
        <path fill="#fff" d="M14.8,22.9H23V12.6h-8.2V22.9z M20.1,14c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1
          C19,14.5,19.5,14,20.1,14z M18.1,18.6c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6
          C16.5,19.3,17.2,18.6,18.1,18.6z"/>
      </g>
    </g>
  </SvgIcon>
);

//-5 0 30 30
export const SpeedCameraMenu = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
        <path d="M19.6,23.1H9.5V9.3h10.1V23.1z M10.7,21.9h7.7V10.5h-7.7V21.9z"/>
        <path d="M25.8,21.6h-3.2v-6.9h3.2V21.6z M23.9,20.4h0.8v-4.5h-0.8V20.4z"/>
        <path d="M17,12.6c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.5,11.4,17,12,17,12.6z"/>
        <rect x="20.5" y="12.2" width="1.2" height="9.4"/>
    <path d="M14,16.4c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4s2.3-1.1,2.4-2.4C16.4,17.5,15.3,16.4,14,16.4z M14,20
  c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2C15.2,19.5,14.7,20,14,20z"/>
  </SvgIcon>
);

export const Car = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
       <g>
      <g>
        <path d="M26.4,17.8H15.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h10.6c0.3,0,0.5,0.2,0.5,0.5S26.7,17.8,26.4,17.8z"/>
      </g>
      <g>
        <path d="M25,23.4h-6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5S25.3,23.4,25,23.4z"/>
      </g>
      <g>
        <path d="M27,25.2c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3s2.3,1,2.3,2.3S28.2,25.2,27,25.2z M27,21.6
          c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S27.6,21.6,27,21.6z"/>
      </g>
      <g>
        <path  d="M16.9,25.2c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3S18.2,25.2,16.9,25.2z M16.9,21.6
          c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2S17.5,21.6,16.9,21.6z"/>
      </g>
      <g>
        <path d="M29.8,23.2h-0.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h0.9c0.2,0,0.4-0.2,0.4-0.3v-2.7c0,0-0.1-0.5-0.5-0.6
          l-3.2-0.7c-0.7-0.2-1.2-1.1-1.8-2.1c-0.3-0.5-0.8-1.5-1.1-1.5l-5,0c-0.3,0.1-0.8,1-1.1,1.5c-0.5,1-1,1.9-1.8,2.1l-2.5,0.7
          c-0.5,0.1-0.6,0.6-0.6,0.6v2.7c0,0.1,0.2,0.3,0.4,0.3h1.7c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-1.7c-0.7,0-1.5-0.6-1.5-1.4
          v-2.7c0-0.6,0.4-1.5,1.4-1.7l2.5-0.7c0.3-0.1,0.8-1,1.1-1.5c0.6-1.1,1.2-2.1,2-2.1h5c0,0,0,0,0,0c0.9,0,1.4,1,2,2.1
          c0.3,0.5,0.8,1.4,1,1.5l3.2,0.7c1,0.2,1.4,1.1,1.4,1.7v2.7C31.3,22.6,30.5,23.2,29.8,23.2z"/>
      </g>
    </g>
  </SvgIcon>
);

export const Pin = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path d="M21.9,28.8L21.2,28c-0.6-0.8-6-8.2-6-11.6c0-3.7,3-6.6,6.6-6.6c3.7,0,6.6,3,6.6,6.6c0,3.4-5.4,10.8-6,11.6
      L21.9,28.8z M21.9,11.3c-2.8,0-5,2.3-5,5c0,2.1,3.2,7.1,5,9.7c1.8-2.6,5-7.6,5-9.7C26.9,13.6,24.6,11.3,21.9,11.3z" />
  </SvgIcon>
);

export const Ruler = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path d="m25.2472,12.79799c-0.3,0 -0.6,0.3 -0.6,0.6l0,4.4l-2.8,0l0,-2.4c0,-0.3 -0.3,-0.6 -0.6,-0.6s-0.6,0.3 -0.6,0.6l0,2.4l-3.8,0l0,-4.4c0,-0.3 -0.3,-0.6 -0.6,-0.6s-0.6,0.3 -0.6,0.6l0,4.4l-2.8,0l0,-2.4c0,-0.3 -0.3,-0.6 -0.6,-0.6s-0.6,0.3 -0.6,0.6l0,2.4l-3.8,0l0,-4.4c0,-0.3 -0.3,-0.6 -0.6,-0.6s-0.6,0.3 -0.6,0.6l0,5c0,0.3 0.3,0.6 0.6,0.6l18,0c0.3,0 0.6,-0.3 0.6,-0.6l0,-5c0,-0.3 -0.3,-0.6 -0.6,-0.6z"/>
  </SvgIcon>
);

export const Pozicionet = props => (
  <SvgIcon viewBox="0 0 26 26" {...props}>
  <path d="M21.7,13h-1.1c-0.4-3.4-3.1-6.1-6.5-6.5V5.4c0-0.4-0.3-0.8-0.8-0.8S12.6,5,12.6,5.4v1.1
  C9.3,6.8,6.5,9.6,6.2,13H5.1c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h1.1c0.4,3.4,3.1,6.1,6.5,6.5v1c0,0.4,0.3,0.8,0.8,0.8
  s0.8-0.3,0.8-0.8v-1c3.4-0.4,6.1-3.1,6.5-6.5h1.1c0.4,0,0.8-0.3,0.8-0.8S22.1,13,21.7,13z M14.1,19.4v-1c0-0.4-0.3-0.8-0.8-0.8
  s-0.8,0.3-0.8,0.8v1C10.1,19.1,8,17,7.7,14.5h1c0.4,0,0.8-0.3,0.8-0.8S9.1,13,8.7,13h-1C8,10.4,10.1,8.3,12.6,8v1
  c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V8c2.6,0.3,4.6,2.4,4.9,4.9h-1c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h1
  C18.8,17,16.7,19.1,14.1,19.4z"/>
<path d="M13.4,11.1c-1.5,0-2.6,1.2-2.6,2.6c0,1.5,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6C16,12.2,14.9,11.1,13.4,11.1z
   M13.4,14.9c-0.7,0-1.1-0.6-1.1-1.1c0-0.7,0.6-1.1,1.1-1.1c0.7,0,1.1,0.5,1.1,1.1C14.5,14.4,14,14.9,13.4,14.9z"/>
   </SvgIcon>
);

export const Edit = props => (
  <SvgIcon style={styles.iconHover} viewBox="1 1 26 26" {...props}>
	<g id="ic-write_2_">
		<path id="Combined-Shape_16_" d="M6.3,20.4c0-0.4,0.3-0.8,0.7-0.8h4.5c0.4,0,0.7,0.3,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7
			H7.1C6.6,21.1,6.3,20.8,6.3,20.4z M13.1,20.4c0-0.4,0.3-0.8,0.8-0.8h3.7c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.7-0.8,0.7h-3.7
			C13.4,21.1,13.1,20.8,13.1,20.4z M19.1,20.4c0-0.4,0.3-0.8,0.7-0.8h0.8c0.4,0,0.7,0.3,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7h-0.8
			C19.4,21.1,19.1,20.8,19.1,20.4z"/>
		<path id="Rectangle-85_2_" d="M10.2,16.4l2.6-0.5l5.7-5.7c0.3-0.3,0.3-0.8,0-1.1l-1.1-1.1c-0.3-0.3-0.8-0.3-1.1,0
			l-5.7,5.7L10.2,16.4z M8.4,18.3l1-5.2l6-6c0.9-0.9,2.3-0.8,3.1,0.1l1,1.1c0.9,0.9,0.9,2.3,0.1,3.1l-6,6L8.4,18.3z"/>
	</g>
   </SvgIcon>
);

export const Gps = props => (
  <SvgIcon style={styles.iconHover} viewBox="0 0 20 18.9" {...props}>
    <g>
      <circle cx="10.2" cy="9.7" r="6.5"/>
      <g>
        <line x1="14.9" y1="9.7" x2="18.4" y2="9.7"/>
        <line x1="1.9" y1="9.7" x2="5.4" y2="9.7"/>
      </g>
      <g>
        <line x1="10.2" y1="5" x2="10.2" y2="1.4"/>
        <line x1="10.2" y1="17.9" x2="10.2" y2="14.4"/>
      </g>
      <path d="M12.1,9.7c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9C11.2,7.8,12.1,8.6,12.1,9.7z" />
    </g>
  </SvgIcon>
);

export const Latvia = props => (
  <SvgIcon style={styles.iconHover} viewBox="0 0 27.5 27.1" {...props}>
	<path d="M19,19.2c-0.1,0-0.2,0-0.3-0.1l-4.5-2.5l-0.6,0.4c-0.1,0-0.2,0.1-0.3,0.1l-6.1-0.2l-2.1,1.3
  c-0.2,0.1-0.4,0.1-0.6,0c-0.2-0.1-0.3-0.3-0.3-0.5l-0.1-2.8c0-0.1,0-0.1,0-0.2l1.2-3.2c0-0.1,0.1-0.2,0.2-0.3l2.6-1.8
  c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.3,0.1,0.4,0.3l1.8,3l0.7,0.3l0.8-0.2l0.3-0.9l-0.4-2.4c0-0.3,0.1-0.5,0.3-0.6l2.5-1
  c0.2-0.1,0.3,0,0.5,0l2.6,1.6h0.8l1.6,0.1c0.2,0,0.3,0.1,0.4,0.2l1,1.2c0.1,0.1,0.1,0.3,0.1,0.4l-0.2,1.2l0.2,0.1
  c0.2,0.1,0.3,0.2,0.4,0.4l0.8,2.9c0,0.2,0,0.3-0.1,0.5L22,18.1c-0.1,0.1-0.2,0.2-0.3,0.2l-2.5,0.8C19.1,19.1,19.1,19.2,19,19.2z
   M14.2,15.4c0.1,0,0.2,0,0.3,0.1l4.6,2.6l2.1-0.7l1-1.4l-0.7-2.4L21,13.4c-0.3-0.1-0.4-0.3-0.4-0.6l0.3-1.4l-0.7-0.8l-1.4-0.1l-1,0
  c-0.1,0-0.2,0-0.3-0.1l-2.5-1.6l-1.8,0.7l0.3,2.1c0,0.1,0,0.2,0,0.2l-0.4,1.3c-0.1,0.2-0.2,0.3-0.4,0.4l-1.3,0.4
  c-0.1,0-0.3,0-0.4,0l-1-0.5c-0.1,0-0.2-0.1-0.2-0.2l-1.6-2.6l-2,1.4l-1.1,2.9l0.1,1.7l1.4-0.9c0.1-0.1,0.2-0.1,0.3-0.1l6.1,0.2
  l0.8-0.4C14,15.4,14.1,15.4,14.2,15.4z"/>
  </SvgIcon>
);

export const Riga = props => (
<SvgIcon style={styles.iconHover} viewBox="0 0 27.5 27.1" {...props}>
<path d="M12.4,21.5c-1.7,0-3.3-0.5-4.2-1.2c-1-0.9-1-2.4-0.9-3.9c0.2-1.4,0.3-3.6,0.3-4.4c-0.1,0-0.2-0.1-0.3,0
c-0.3,0.1-0.7,0.5-1,0.7c-0.2,0.2-0.4,0.3-0.6,0.3c-0.2,0-0.5-0.2-0.5-0.4c-0.1-0.2-0.2-0.8-0.2-1.2C5,10.1,5.6,9.5,6.6,8.9
L5.8,6.8C5.7,6.6,5.8,6.3,6,6.2C6.2,6,6.4,6,6.6,6.2l1.3,0.9l0.5-0.9C8.5,6.1,8.7,6,8.9,6c0.2,0,0.4,0.1,0.5,0.3l0.5,0.9l1.3-0.7
c0.2-0.1,0.4-0.1,0.6,0.1C11.9,6.7,12,7,11.9,7.2l-1.1,2.7c0.2,1.7,0.4,3.7,0.6,4.5c0.5-0.1,1.3-0.3,2.1-0.6c0-0.1,0-0.2,0-0.3
c0.1-1.3,0.3-3.9,1.9-5.3c0.9-0.7,2-1,3.4-0.8c1.9,0.2,3.4,1.2,4.1,2.8c0.7,1.5,0.6,3.5-0.2,4.8c-0.3,0.5-1.6,2.6-1.6,2.6
c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0-0.3,0-0.4-0.1l-1.3-1c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.4,0.3-1.5,0-2.1c-0.1-0.1-0.2-0.3-0.6-0.3
c-0.4,0-0.5,0.1-0.6,0.2c-0.3,0.3-0.4,1-0.4,1.4c0.6,1,1.2,3.1-0.4,4.7C15.7,21,14,21.5,12.4,21.5z M7.3,10.8c0.6,0,1,0.3,1.2,0.5
c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1-0.1,2.9-0.3,4.7c-0.1,1.4-0.1,2.4,0.5,2.9c1.3,1.1,5.2,1.7,7.3-0.3c1.4-1.4,0.2-3.3,0.1-3.4
c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.2-0.1-1.6,0.7-2.4c0.3-0.3,0.7-0.5,1.5-0.5c0.6,0.1,1.1,0.3,1.4,0.8c0.5,0.8,0.4,2,0.3,2.6l0.5,0.4
c0.4-0.7,1.1-1.7,1.3-2.1c0.7-1,0.7-2.6,0.2-3.7c-0.4-0.8-1.3-1.9-3.3-2.1c-1.1-0.1-1.9,0-2.5,0.6c-1.3,1.1-1.5,3.4-1.5,4.5
c0,0.7-0.1,1-0.5,1.2c-1,0.4-2.7,0.8-3.1,0.8c-0.5,0-0.8,0-1.3-5.7c0-0.1,0-0.2,0-0.3l0.6-1.5L9.8,8.4c-0.3,0.1-0.6,0-0.7-0.2
L8.9,7.7L8.6,8.2C8.5,8.3,8.4,8.4,8.2,8.4c-0.2,0-0.3,0-0.4-0.1L7.4,8.1l0.4,1c0.1,0.2,0,0.4-0.1,0.5C7.6,9.8,7.5,9.8,7.3,9.8
c0,0-0.1,0-0.2,0C6.2,10.4,6,10.8,6,11.4c0.3-0.2,0.6-0.4,1-0.5C7.1,10.8,7.2,10.8,7.3,10.8z M11.5,14.7L11.5,14.7L11.5,14.7z"/>
</SvgIcon>);

export const GoTo = props => (
  <SvgIcon viewBox="-6 -7 28 28" {...props}>
	<path d="M5.67,4.47c-0.24-0.24-0.62-0.24-0.85,0c-0.24,0.24-0.24,0.62,0,0.85l1.6,1.6H1.18c-0.33,0-0.6,0.27-0.6,0.6
		s0.27,0.6,0.6,0.6h5.24l-1.6,1.6c-0.24,0.24-0.24,0.62,0,0.85c0.12,0.12,0.27,0.18,0.43,0.18s0.31-0.06,0.43-0.18l3.06-3.06
		L5.67,4.47z"/>
	<polygon points="1.92,0.57 1.92,3.59 3.23,3.59 3.23,1.87 12.42,1.87 12.42,13.32 3.23,13.32 3.23,11.59 1.92,11.59 
		1.92,14.62 13.73,14.62 13.73,0.57 	"/>
  </SvgIcon>
);

export const Manakarte = props => (
  <SvgIcon viewBox="-1 -2 44 44" {...props}>
	<path d="M22.5,24.4l-0.6-0.8c-0.5-0.7-4.8-6.6-4.8-9.3c0-3,2.4-5.4,5.4-5.4s5.4,2.4,5.4,5.4c0,2.8-4.3,8.7-4.8,9.3
		L22.5,24.4z M22.5,10.4c-2.1,0-3.9,1.7-3.9,3.9c0,1.5,2.2,5.1,3.9,7.5c1.7-2.4,3.9-6,3.9-7.5C26.4,12.1,24.6,10.4,22.5,10.4z"/>
	<polygon points="31.6,18.8 28.1,18.8 28.1,20.3 30.1,20.3 30.1,27 14.9,27 14.9,20.3 16.9,20.3 16.9,18.8 13.3,18.8 
		13.3,28.6 31.6,28.6 	"/>
  </SvgIcon>
);

export const TIC = props => (
  <SvgIcon viewBox="2 2 28 28" {...props}>
    <g>
      <path d="M9.3,6.8v15.7H25V6.8H9.3z M23.8,21.3H10.5V8h13.3V21.3z"/>
      <rect x="16.3" y="12.6" width="1.8" height="6.6"/>
      <path d="M17.2,11.8c0.3,0,0.6-0.1,0.7-0.2s0.2-0.4,0.2-0.6c0-0.6-0.3-0.9-1-0.9s-1,0.3-1,0.9
        C16.2,11.5,16.5,11.8,17.2,11.8z"/>
    </g>
  </SvgIcon>
)

export const Swamp = props => (
  <SvgIcon viewBox="-6 -8 30 30" {...props}>
    <g>
      <g>
        <path d="M18.2,9.9h-4.3V8.7h4.3V9.9z M12,9.9H7.7V8.7H12V9.9z M5.7,9.9H1.5V8.7h4.3V9.9z"/>
      </g>
      <g>
        <path d="M15,13.6h-4.3v-1.2H15V13.6z M8.7,13.6H4.5v-1.2h4.3V13.6z"/>
      </g>
      <g>
        <path d="M15,6.2h-4.3V5H15V6.2z M8.7,6.2H4.5V5h4.3V6.2z"/>
      </g>
    </g>
  </SvgIcon>
)

export const Island = props => (
  <SvgIcon viewBox="-6 -8 30 30" {...props}>
    <g>
      <g>
        <g>
          <path d="M18.5,15.2c-1.1,0-1.7-0.7-2.2-1.2c-0.4-0.5-0.7-0.8-1.2-0.8s-0.8,0.3-1.2,0.8c-0.5,0.5-1,1.2-2.2,1.2
            c-1.1,0-1.7-0.7-2.1-1.2c-0.4-0.5-0.7-0.8-1.2-0.8c-0.5,0-0.8,0.3-1.2,0.8c-0.5,0.5-1,1.2-2.1,1.2S3.3,14.5,2.8,14
            c-0.4-0.5-0.7-0.8-1.2-0.8V12c1.1,0,1.7,0.7,2.1,1.2C4.1,13.7,4.4,14,5,14c0.5,0,0.8-0.3,1.2-0.8c0.5-0.5,1-1.2,2.1-1.2
            s1.7,0.7,2.1,1.2c0.4,0.5,0.7,0.8,1.2,0.8c0.5,0,0.8-0.3,1.2-0.8c0.5-0.5,1-1.2,2.2-1.2s1.7,0.7,2.2,1.2c0.4,0.5,0.7,0.8,1.2,0.8
            V15.2z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M18.5,5.9c-1.1,0-1.7-0.7-2.2-1.2c-0.4-0.5-0.7-0.8-1.2-0.8s-0.8,0.3-1.2,0.8c-0.5,0.5-1,1.2-2.2,1.2
            c-1.1,0-1.7-0.7-2.1-1.2C9.1,4.2,8.9,3.9,8.3,3.9c-0.5,0-0.8,0.3-1.2,0.8C6.6,5.2,6.1,5.9,5,5.9S3.3,5.2,2.8,4.7
            C2.4,4.2,2.1,3.9,1.6,3.9V2.7c1.1,0,1.7,0.7,2.1,1.2C4.1,4.4,4.4,4.7,5,4.7c0.5,0,0.8-0.3,1.2-0.8c0.5-0.5,1-1.2,2.1-1.2
            s1.7,0.7,2.1,1.2c0.4,0.5,0.7,0.8,1.2,0.8c0.5,0,0.8-0.3,1.2-0.8c0.5-0.5,1-1.2,2.2-1.2s1.7,0.7,2.2,1.2c0.4,0.5,0.7,0.8,1.2,0.8
            V5.9z"/>
        </g>
      </g>
      <g>
        <path d="M5.2,10.7c-1.2,0-1.8-0.7-2.2-1.2C2.5,9,2.2,8.7,1.6,8.7c0,0,0,0,0,0l0-1.2c0,0,0,0,0,0
          c1.2,0,1.8,0.7,2.2,1.2c0.5,0.5,0.7,0.8,1.3,0.8c0,0,0,0,0,0c0.6,0,0.9-0.3,1.3-0.8C7,8.2,7.6,7.5,8.7,7.5v1.2
          C8.1,8.7,7.9,9,7.4,9.5C6.9,10.1,6.3,10.7,5.2,10.7C5.2,10.7,5.2,10.7,5.2,10.7z"/>
      </g>
      <g>
        <path d="M18.4,11h-8.4v-0.6c0-2.2,1.8-3.9,4.2-3.9s4.2,1.7,4.2,3.9V11z M11.3,9.8h5.8c-0.3-1.2-1.5-2.1-2.9-2.1
          S11.6,8.6,11.3,9.8z"/>
      </g>
    </g>
  </SvgIcon>
)

export const ParkForest = props => (
  <SvgIcon viewBox="-6 -8 30 30" {...props}>
    <g>
      <g>
        <g>
          <path d="M12.3,14.6c-1,0-1.9-0.4-2.6-1.1c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.5,0.5,1.1,0.8,1.8,0.8
            c1.4,0,2.5-1.1,2.5-2.5c0-1-0.6-1.9-1.5-2.3c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.2,0-0.4,0.1-0.5c0.3-0.5,0.5-1,0.5-1.6
            c0-1.4-0.6-2-2.3-2c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.1-0.4,0.1-0.6c0.1-0.1,0.1-0.2,0.1-0.6c0,0,0-0.1,0-0.1
            c0-0.7-0.7-1.3-1.5-1.3C8.7,1.4,8,2,8,2.6l0,0.1c0,0.4,0,0.4,0.1,0.5c0.1,0.2,0.2,0.4,0.1,0.6C8.1,4.1,7.9,4.2,7.7,4.2
            c-1.7,0-2.3,0.5-2.3,2c0,0.6,0.2,1.2,0.5,1.6C6,8,6.1,8.2,6,8.3c0,0.2-0.2,0.3-0.3,0.4C4.7,9.1,4.1,10,4.1,11
            c0,1.4,1.1,2.5,2.5,2.5c0.7,0,1.4-0.3,1.8-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8c-0.7,0.7-1.7,1.1-2.7,1.1
            C4.6,14.6,3,13,3,11c0-1.2,0.6-2.4,1.7-3C4.4,7.4,4.2,6.8,4.2,6.2c0-1.8,0.9-2.8,2.6-3.1c0-0.1,0-0.3,0-0.4
            c0-1.4,1.2-2.5,2.6-2.5s2.6,1.1,2.6,2.4c0,0.2,0,0.3,0,0.5c1.8,0.2,2.6,1.2,2.6,3.1c0,0.6-0.1,1.2-0.4,1.8c1,0.7,1.7,1.8,1.7,3
            C16,13,14.3,14.6,12.3,14.6z"/>
        </g>
      </g>
      <g>
        <path d="M12.8,18.2H9.5c-0.3,0-0.6-0.3-0.6-0.6v-9c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v8.5h2.7
          c0.3,0,0.6,0.3,0.6,0.6S13.1,18.2,12.8,18.2z"/>
      </g>
    </g>
  </SvgIcon>
)